// Auto-generated by vibesites deploy pipeline. Do not edit manually.
// Generated: 2026-11-02T22:19:20.352Z
// Property: AURA at Westchase (ID: 6767906449166922)
// Collections: 44 amenities, 21 floorplans (live), 20 photos, 81 POIs, 4 reviews, 4 virtual tours, 6 office hours, 1 special offers (live)
// Live collections (fetched at runtime): floorplans, special_offers

export const property = {
  "multihub_agency_id": "5680529164730368",
  "multihub_company_id": "5734677587427328",
  "multihub_property_id": "6767906449166922",
  "property_external_id": "5587917",
  "property_zillow_url": "https://www.zillow.com/apartments/houston-tx/aura-at-westchase/5Xhs4F/",
  "property_apartments_url": "https://www.apartments.com/aura-at-westchase-houston-tx/zxyqqlw/",
  "property_google_business_url": "https://www.google.com/maps/place/AURA+at+Westchase/data=!4m2!3m1!1s0x0:0xe5d49a62d6c1d285?sa=X&ved=2ahUKEwixtIe80LySAxVc5ckDHaAdClQQ_BJ6BAgYEAA&hl=en&gl=us",
  "property_linkedin_url": null,
  "property_hubspot_id": "39659820981",
  "property_crm_software": "Knock",
  "property_pm_software": "RealPage",
  "property_pm_info": null,
  "property_status": null,
  "property_slug": "aura-at-westchase",
  "property_name": "AURA at Westchase",
  "property_website_url": "https://www.auraatwestchase.com/",
  "property_domain": "https://www.auraatwestchase.com/",
  "property_address": "2828 Hayes Road",
  "property_full_address": "2828 Hayes Rd, Houston, TX 77082",
  "property_address_1": "2828 Hayes Road",
  "property_address_2": null,
  "property_address_city": "Houston",
  "property_address_state": "TX",
  "property_address_zip_full": null,
  "property_address_zip": "77082",
  "property_address_country": "US",
  "property_address_county": "Harris County",
  "property_neighborhood_address": "Westside",
  "property_address_latitude": "29.7335862",
  "property_address_longitude": "-95.5762206",
  "property_email": null,
  "property_phone": "8322815617",
  "property_call_tracking_phone": "832-281-5617",
  "property_company_name": "RR Living",
  "property_company_url": "https://www.rrliving.com/",
  "agency_contacts": null,
  "property_type": null,
  "property_short_description": "At AURA at Westchase in Houston, TX, your perfect living space awaits, from spacious one-bedroom retreats to inviting two-bedroom homes. Enjoy an array of amenity-rich experiences, including a state-of-the-art fitness center, serene walking trails, and a pet-friendly environment. Elevate your lifestyle in our gated community today!",
  "property_long_description": "Welcome to AURA at Westchase, your premier apartment community nestled in the heart of Houston, TX. Our meticulously designed one and two-bedroom floor plans offer the perfect blend of luxury and comfort, tailored to fit your lifestyle. \n\nExperience unparalleled convenience with our 24-hour access and controlled entry that ensures a secure living environment. Enjoy a wealth of amenities from our vibrant clubhouse stocked with coffee and tea, to a state-of-the-art fitness center designed to cater to all your workout needs. Cool off in our sparkling pool or fire up the grill at our outdoor BBQ area, all while enjoying the lush walking and biking trails that surround our community.\n\nPet lovers will adore our pet-friendly environment, complete with a dedicated bark park featuring an agility course and a 24-hour pet washing station. Additional conveniences include on-site maintenance, reserved parking options, and online rent payments, ensuring your living experience is as seamless as possible. \n\nOur apartments showcase lavish features, such as high ceilings, granite countertops, stainless steel appliances, and large walk-in closets. With modern comforts like air conditioning, high-speed internet access, and in-unit washer/dryers, you’ll feel right at home. \n\nJoin our welcoming community at AURA at Westchase and enjoy a lifestyle enriched with comfort, convenience, and connection. Don’t wait—find your new home today! Browse our current availability or schedule a tour to explore all that AURA at Westchase has to offer. Your dream apartment awaits!",
  "property_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d204-71f8-9743-d38e5e1a7ea9.webp",
  "property_featured_image_media": {
    "alt_text": "Swimming pool and lounge area with palm trees and apartment buildings in the background.",
    "public_id": "01a0170f-d204-71f8-9743-d38e5e1a7ea9",
    "storage_key": "property/6767906449166922/01a0170f-d204-71f8-9743-d38e5e1a7ea9.webp",
    "width": 1536,
    "height": 1024
  },
  "property_featured_video": "https://media.multihub.io/property/6767906449166922/01a035e6-fb3a-7218-b0e8-61d64f7e645e.mp4",
  "property_featured_video_media": {
    "public_id": "01a035e6-fb3a-7218-b0e8-61d64f7e645e",
    "storage_key": "property/6767906449166922/01a035e6-fb3a-7218-b0e8-61d64f7e645e.mp4",
    "thumbnail_key": "property/6767906449166922/01a035e6-fb3a-7218-b0e8-61d64f7e645e_thumb.webp",
    "size_bytes": 75461600,
    "classification": "Apartment",
    "title": "Spacious and Modern Apartment Unit Tour",
    "description": "Tour this beautifully appointed apartment unit, featuring a modern kitchen, elegant bathroom, and comfortable living spaces. Discover your new home today."
  },
  "property_total_units": "510",
  "property_year_built": "1995",
  "property_year_renovated": null,
  "property_walk_score": null,
  "property_transit_score": null,
  "property_business_hours_list": null,
  "property_current_occupancy": "77.64705882352942",
  "property_admin_fee": "125",
  "property_application_fee": "50",
  "property_fees_deposit_info": null,
  "property_ispetfriendly": true,
  "property_allows_cats": true,
  "property_allows_dogs": true,
  "property_upfront_pet_fee": "500",
  "property_pet_deposit": null,
  "property_monthly_pet_rent": "50",
  "property_max_pets": "2",
  "property_max_pet_weight_limit": "100",
  "property_pet_restrictions": "Maximum of 2 pets per unit. Weight limit: 100 lb per pet.",
  "property_pet_policy_description": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_petpolicy_info": null,
  "property_online_leasing_url": "https://9260950.onlineleasing.realpage.com/",
  "property_resident_portal_url": "https://auraatwestchase.loftliving.com/login",
  "property_apply_now_url": "https://9260950.onlineleasing.realpage.com/",
  "property_community_amenities_list": null,
  "property_apartment_features_list": null,
  "property_primary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019e60cc-cd89-70d0-b2f5-b86967ee2d5a.webp",
  "property_primary_logo_media": {
    "alt_text": "Aura at Westchase logo",
    "public_id": "019e60cc-cd89-70d0-b2f5-b86967ee2d5a",
    "storage_key": "property/6767906449166922/019e60cc-cd89-70d0-b2f5-b86967ee2d5a.webp",
    "width": 3072,
    "height": 3072
  },
  "property_secondary_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019e60cc-e9aa-71d9-bf38-691ea915db72.webp",
  "property_secondary_logo_media": {
    "alt_text": "Aura at Westchase logo",
    "public_id": "019e60cc-e9aa-71d9-bf38-691ea915db72",
    "storage_key": "property/6767906449166922/019e60cc-e9aa-71d9-bf38-691ea915db72.webp",
    "width": 3072,
    "height": 3072
  },
  "property_icon": null,
  "property_icon_media": null,
  "property_fav_icon": null,
  "property_fav_icon_media": null,
  "property_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019e8e86-cc9e-72b1-b6c8-060ce79f2dba.webp",
  "property_mono_white_logo_media": {
    "alt_text": "Aura at Westchase logo.",
    "public_id": "019e8e86-cc9e-72b1-b6c8-060ce79f2dba",
    "storage_key": "property/6767906449166922/019e8e86-cc9e-72b1-b6c8-060ce79f2dba.webp",
    "width": 1280,
    "height": 1280
  },
  "property_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019e8e86-c192-7541-8a80-8055e0d7e07a.webp",
  "property_mono_black_logo_media": {
    "alt_text": "Aura at Westchase logo",
    "public_id": "019e8e86-c192-7541-8a80-8055e0d7e07a",
    "storage_key": "property/6767906449166922/019e8e86-c192-7541-8a80-8055e0d7e07a.webp",
    "width": 1280,
    "height": 1280
  },
  "property_company_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595d-b89d-716c-8cb0-24426d93f0d6.webp",
  "property_company_icon_media": null,
  "property_company_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_black_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
  "property_company_mono_black_logo_media": {
    "alt_text": "RR Living logo",
    "public_id": "019d595e-2b5f-71d5-85c8-a7b454bb3a35",
    "storage_key": "company/5734677587427328/019d595e-2b5f-71d5-85c8-a7b454bb3a35.webp",
    "width": 1500,
    "height": 1500
  },
  "property_company_mono_white_logo": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
  "property_company_mono_white_logo_media": {
    "alt_text": "RR Living logo with RRL text",
    "public_id": "019d06ca-1e49-754a-93ba-7ae4659a0d68",
    "storage_key": "company/5734677587427328/019d06ca-1e49-754a-93ba-7ae4659a0d68.webp",
    "width": 640,
    "height": 640
  },
  "property_primary_color": "#000b2d",
  "property_secondary_color": "#eaac3b",
  "property_font_color": "#0d204f",
  "property_color_4": null,
  "property_color_3": null,
  "property_color_5": null,
  "property_color_6": null,
  "property_color_7": null,
  "property_color_8": null,
  "property_bedrooms_range": "1 - 2",
  "property_bedrooms_min": "1",
  "property_bedrooms_max": "2",
  "property_bathrooms_range": "1 - 2",
  "property_bathrooms_min": "1",
  "property_bathrooms_max": "2",
  "property_sqft_range": "675 - 1454",
  "property_sqft_min": "675",
  "property_sqft_max": "1454",
  "property_price_range": "969 - 2100",
  "property_price_min": "969",
  "property_price_max": "2100",
  "property_available_units": 114,
  "property_facebook_url": "https://www.facebook.com/AURAatWestchase/",
  "property_instagram_url": "https://www.instagram.com/aurawestchase/",
  "property_twitter_url": null,
  "property_google_place_url": "https://www.google.com/maps/place/?q=place_id:ChIJ8xeZc8TcQIYRhdLB1mKa1OU",
  "property_youtube_url": null,
  "property_yelp_url": "https://www.yelp.com/biz/aura-houston-houston",
  "property_tiktok_url": "https://www.tiktok.com/@aura.at.westchase",
  "property_specialoffer_title": null,
  "property_specialoffer_description": null,
  "property_specialoffer_disclaimer": null,
  "property_home_hero_title": "Welcome to AURA at Westchase",
  "property_home_romance_title": "Embrace Joyful Living in Your Dream Apartment Home",
  "property_home_amenities_blurb": "<p>Welcome to AURA at Westchase Apartment Homes in Houston, Texas, where luxury meets comfort in our spacious one and two-bedroom residences. Our apartment homes are a blend of sophistication and convenience, featuring modern open floor plans, wood-inspired flooring, and sleek granite countertops. While amenities vary, select homes boast energy-efficient stainless-steel appliances, custom designer cabinetry, and serene pool views from private patios or balconies. Embrace a community designed for vibrant living, complete with a state-of-the-art fitness center, a pet-friendly atmosphere with dedicated dog parks, and a calendar filled with engaging social events. Experience the epitome of Houston living at AURA at Westchase, where every detail is curated with your comfort and enjoyment in mind.</p>",
  "property_home_floorplans_blurb": "<p>Experience the elegance, quality, and style found only at AURA at Westchase apartments. Each of our one or two bedroom open-concept floor plans features a full-size washer and dryer and a host of premium amenities.</p>",
  "property_home_gallery_blurb": "<p>Westchase is largely known as a business district, and many of the local residents are corporate professionals seeking to avoid the long, traffic-laden commutes that Houston is known for. The community is home to numerous office buildings, with a popular shopping area along Westheimer Road and several medical centers and schools in the mix as well. The rental market includes a variety of property styles, from swanky country club homes to modest efficiency apartments, catering to the needs of the diverse local workforce.</p>\n<p>Golf courses and large public parks around Westchase are popular among locals seeking time outdoors, particularly the trails around Arthur Storey Park. Houston’s Chinatown is nearby, and Asian cultural influences contribute to a unique environment. Downtown Houston is only a short drive to the east, and the sprawling George Bush Park is just a quick hop away as well.</p>",
  "property_home_neighborhood_blurb": "At AURA at Westchase, vibrant living meets exceptional convenience. Nestled in Houston, our community places you near lush parks like George Bush Park and Bear Creek Pioneers Park, top-tier educational institutions, and dynamic businesses. Embrace an active lifestyle while enjoying easy access to shopping and entertainment hotspots—your ideal urban escape awaits!",
  "property_home_reviews_blurb": "Welcome to AURA at Westchase, where our residents continually praise the welcoming atmosphere and exceptional amenities. With a spacious floor plan, lush greenery, and a commitment to community connection, you’ll find comfort and security here. Join us and experience the vibrant lifestyle that makes AURA feel like home!",
  "property_neighborhood_blurb": "<p>Westchase is largely known as a business district, and many of the local residents are corporate professionals seeking to avoid the long, traffic-laden commutes that Houston is known for. The community is home to numerous office buildings, with a popular shopping area along Westheimer Road and several medical centers and schools in the mix as well. The rental market includes a variety of property styles, from swanky country club homes to modest efficiency apartments, catering to the needs of the diverse local workforce.</p>\n<p>Golf courses and large public parks around Westchase are popular among locals seeking time outdoors, particularly the trails around Arthur Storey Park. Houston’s Chinatown is nearby, and Asian cultural influences contribute to a unique environment. Downtown Houston is only a short drive to the east, and the sprawling George Bush Park is just a quick hop away as well.</p>",
  "property_accessibility_blurb": null,
  "property_amenities_blurb": "<p>Embrace a lifestyle of comfort, quality, and style with designer features in every home! Your worries will fade as you relax in your spa-inspired soaking tub, available in select homes. Imagine basking in the sun and being refreshed by the cool waters lapping over you as you lounge in our resort-style pools. Come and discover all the wonderful amenities at AURA at Westchase in Houston, TX.</p>",
  "property_applynow_blurb": "At AURA at Westchase in Houston, TX, our one and two-bedroom apartments blend comfort with modern living. Enjoy lavish amenities like a resort-style pool, a state-of-the-art fitness center, and a pet-friendly community complete with a bark park. Lease online today and elevate your lifestyle in an inviting space!",
  "property_contactus_blurb": "At AURA at Westchase in Houston, TX, our thoughtfully designed one and two-bedroom floor plans cater to your lifestyle needs. Experience modern living in a vibrant community. Have questions? Our leasing team is here to assist you today! Transform your living experience at AURA—your new home awaits.",
  "property_faqs_blurb": "At AURA at Westchase in Houston, TX, your ideal living space awaits with thoughtfully designed one and two-bedroom floor plans. Enhance your lifestyle and satisfaction—take a moment to browse our FAQs page and get insights into our vibrant community and the amenities that make AURA truly exceptional.",
  "property_floorplans_blurb": "<p>Experience the elegance, quality, and style found only at AURA at Westchase apartments. Each of our one or two-bedroom open-concept floor plans features a full-size washer and dryer and a host of premium amenities.</p>",
  "property_gallery_blurb": "<p>Your personal space, the place you call your own. It's the room where you end your day and start it, and where you deserve to feel as relaxed as possible.</p>",
  "property_interactivemap_blurb": "Welcome to AURA at Westchase, where luxury meets livability in Houston, TX. Choose from our stylish one and two-bedroom floor plans, each designed for comfort and convenience. Enjoy 24-hour access to top-notch amenities like a fitness center, pool, and bark park, all within a gated community. Start your journey today!",
  "property_pets_blurb": "<p>RR Living knows the importance of pets to their fur-parents, so we prioritize them in the living experience at our communities.</p><p>Our residents enjoy Bark Parks, SantaPaws Events and Treats & Tails Socials. Learn more about our <a href=\"https://app.petscreening.com\">pet policy</a> through our partner, <a href=\"https://app.petscreening.com\">PetScreening</a>.</p><p>We are proud to offer no breed restrictions at this community. Each apartment may have up to 3 pets, with a limit of 2 dogs per home. A non-refundable, one-time pet fee is required for each pet. Veterinary documentation may be requested.</p>",
  "property_referafriend_blurb": "At AURA at Westchase in Houston, TX, we believe that friendships flourish in the perfect environment. With inviting one- and two-bedroom floor plans, your dream home awaits. Share the love—refer a friend today and enhance your living experience with great neighbors! ",
  "property_residentaccess_blurb": "At AURA at Westchase in Houston, TX, convenience meets comfort in our thoughtfully designed one and two-bedroom apartments. Easily manage your home life through our resident portal—pay rent, schedule maintenance, and stay connected. Access the sophistication and ease of living that sets AURA apart today!",
  "property_reviews_blurb": "Experience a vibrant lifestyle at AURA at Westchase, where our friendly team is dedicated to making every resident feel at home. With spacious floor plans, excellent amenities, and a commitment to community engagement, residents rave about the welcoming atmosphere: “I've never felt safer… I loved it and I wish to stay there again.”",
  "property_created_at": "1763066811168",
  "property_scheduletour_blurb": "At AURA at Westchase in Houston, TX, our thoughtfully designed one and two-bedroom apartments offer spacious living tailored to your lifestyle. Ready to experience vibrant community living? Schedule a tour today and hear firsthand from our happy residents about their AURA experience! Your new home awaits!",
  "property_thankyou_blurb": "Thank you for reaching out to AURA at Westchase in Houston, TX! Your interest is valued, and we're excited to share our stunning one and two-bedroom floor plans tailored for your lifestyle. A team member will connect with you soon to guide you toward your perfect home.",
  "property_virtualtours_blurb": "<p>At AURA at Westchase, we make finding your new home quick & easy with our beautiful virtual tours. Explore 360-degree views of your new apartment home & the exceptional amenities that accompany it.</p>",
  "property_copyright": "2026 All Rights Reserved. AURA at Westchase",
  "property_seo_title_home": "AURA at Westchase |  Apartments in Houston, TX",
  "property_seo_description_home": "Experience modern living at AURA at Westchase in Houston, TX. Enjoy luxurious amenities, pet-friendly spaces, and spacious floor plans. Your new home awaits!",
  "property_seo_title_floorplans": "Floor Plans | Houston, TX Apartments for Rent",
  "property_seo_description_floorplans": "Unlock your ideal living space at AURA at Westchase in Houston, TX. From cozy one-bedroom to spacious two-bedroom options, find your perfect floor plan today!",
  "property_seo_title_amenities": "Amenities | Houston, TX Apartments for Rent",
  "property_seo_description_amenities": "Experience luxury living at AURA at Westchase, Houston! Enjoy modern amenities, from a 24-hour fitness center to pet-friendly parks. Your oasis awaits!",
  "property_seo_title_gallery": "Gallery | Apartments in Houston, TX",
  "property_seo_description_gallery": "Imagine life at AURA at Westchase! Luxurious apartments with stunning amenities in Houston, TX. Check out our photo gallery and envision your new home!",
  "property_seo_title_virtualtours": "Virtual Tours | AURA at Westchase Apartments",
  "property_seo_description_virtualtours": "Step inside AURA at Westchase in Houston, TX! Enjoy a virtual tour of our one and two-bedroom apartments and envision your new home today!",
  "property_seo_title_interactivemap": "Interactive Map | AURA at Westchase Apartments",
  "property_seo_description_interactivemap": "Find your perfect home at AURA at Westchase! Use our interactive map to browse one and two-bedroom floor plans and explore incredible amenities in Houston.",
  "property_seo_title_neighborhood": "Neighborhood | Apartments in Houston, TX",
  "property_seo_description_neighborhood": "Immerse yourself in the vibrant community surrounding AURA at Westchase in Houston, TX. Uncover local gems and hotspots just steps from your door!",
  "property_seo_title_contact": "Contact Us | AURA at Westchase",
  "property_seo_description_contact": "Elevate your lifestyle at AURA at Westchase in Houston, TX. One and Two bedroom floor plans await you. Have questions? Reach out to our leasing team!",
  "property_seo_title_faqs": "FAQs | Apartments in Houston, TX",
  "property_seo_description_faqs": "Find answers to your questions at AURA at Westchase! Discover unique amenities, pet-friendly features, and a vibrant community in Houston, TX.",
  "property_seo_title_reviews": "Resident Reviews | Apartments in Houston, TX",
  "property_seo_description_reviews": "Experience life at AURA at Westchase! Our residents love the amenities, from a pet-friendly environment to a stunning pool. Read their stories today!",
  "property_seo_title_applynow": "Apply Now | Apartments in Houston, TX",
  "property_seo_description_applynow": "Experience modern living at AURA at Westchase! Choose from spacious 1 & 2 bedroom floor plans with resort-style amenities. Secure your ideal home today!",
  "property_seo_title_residentaccess": "Resident Access | AURA at Westchase",
  "property_seo_description_residentaccess": "Unlock convenience at AURA at Westchase! Log in to your resident portal for effortless rent payments, maintenance requests, and all your community needs.",
  "property_seo_title_referafriend": "Refer A Friend | AURA at Westchase",
  "property_seo_description_referafriend": "Great friends make great neighbors! Refer a friend to AURA at Westchase in Houston, TX, and enjoy vibrant living together in our welcoming community.",
  "property_seo_title_scheduletour": "Schedule a Tour | AURA at Westchase",
  "property_seo_description_scheduletour": "Experience the vibrant lifestyle at AURA at Westchase! Schedule your tour today and find your perfect Houston home surrounded by exceptional amenities.",
  "property_seo_title_privacy": "Privacy Policy | AURA at Westchase",
  "property_seo_description_privacy": "Your privacy matters at AURA at Westchase. Learn how we protect your personal information and ensure a secure living environment in Houston, TX.",
  "property_seo_title_accessibility": "Website Accessibility | AURA at Westchase",
  "property_seo_description_accessibility": "Experience seamless living at AURA at Westchase, Houston. Our commitment to accessibility makes everyone feel at home. Join us today!",
  "property_seo_title_sitemap": "Sitemap | AURA at Westchase",
  "property_seo_description_sitemap": "Navigate your future home at AURA at Westchase in Houston, TX. Check out our sitemap for easy access to amenities, floor plans, and local hotspots!",
  "property_seo_title_thankyou": "Thank You | AURA at Westchase",
  "property_seo_description_thankyou": "Thank you for reaching out to AURA at Westchase! Our team will connect with you soon to guide you home to modern living in Houston, TX.",
  "property_seo_title_pets": "Pet Policy | Apartments in Houston, TX",
  "property_seo_description_pets": "Discover our comprehensive pet policy designed to ensure a comfortable and welcoming environment for you and your furry companions.",
  "property_updated_at": "1793119009632",
  "amenities": [
    {
      "id": "custom_e8c711ee-e12c-4d84-abd9-e5b412829aa1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Two Shimmering Swimming Pools with Outdoor Fire Pit Lounge and Grilling Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_77e7f844-f1d2-4847-a47c-802bae6dd02e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Bark Park with Agility Course",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_05cec8ab-824a-4446-a623-0908a950ae42",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour State‑of‑the‑art Fitness Center",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_483af3d5-4dec-4cf2-8bf7-7418de879c2a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Pet Washing Station",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b513ebad-8f49-4841-80ef-c6967f4ba71c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Resident Exclusive Clubhouse with Coffee and Tea Bar",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_34035396-3aa8-4869-9bd7-920204faa1fb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Business Center with Free WIFI",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_69340b44-4747-4cd8-9cd8-152889327c6b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Door‑to‑Door Valet Trash Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ddb59b84-0ada-4e21-ba93-9159ea4ec669",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Lush Greenery and Beautiful Landscaping",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_0c540806-650e-484e-84ac-a7fbb04eb5c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Pet‑Friendly Walking Paths",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_02a20c4a-bef6-4b76-8959-f2d8b3bbb8df",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Corporate Housing Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6030ad95-f80b-42ed-bed8-baf2ee5b3f84",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Reserved Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_ba7eff74-8241-4f06-ab46-ae5ebdf362fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Private Garages",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_056bf6bb-4ee9-4444-b1a9-ad1d92972327",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Guest Parking Available",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bd7032c9-255a-4965-927f-e9d2d2f9424d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Controlled Access Community",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9e647b8d-6a4f-4efc-8c91-6580a4fc65c3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "24‑Hour Resident Portal",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_411e3277-dbfb-42d7-942b-220185f5dbc2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Online Rent Payments",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_2726452e-1806-422e-b3c1-5e0e2e955ff2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Rent Payment Program",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4e6cf585-5d72-47ed-b369-c6836a16f9a2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Management",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_c0f9e5ff-723f-4908-b465-554ab8ce7f98",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Professional On‑site Maintenance with 24‑Hour Emergency Service",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_a07c973f-826f-402d-956f-4fbe3aec35b2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Active Community Events",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_54422c6c-7ec4-441e-b354-569cc9de23ba",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Flexible Leasing Terms",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf421873-4113-428c-8cbf-0ba1994fed03",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Conveniently Located Near Public Transportation, Freeways, Parks, Shopping, and Restaurants",
      "amount": "false",
      "description": "",
      "group": "Community",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_99405a31-b336-4540-a7bd-942de771f0b6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "9‑Foot Ceilings with Vaulted Ceilings Available",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_6dd9d006-0133-4d84-a8a9-743787adff80",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient, Modern Black Appliance Package with Built‑In Microwave in Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1c92f66c-3dfd-4a66-870c-9486e4206d09",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Energy Efficient, Modern Stainless Steel Appliance Package with Built‑In Microwave in Kitchen*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_059d842e-5d34-474b-b990-bc3faceb7ee4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Upgraded Countertops and Two‑Tone Cabinets in Kitchen and Bathrooms*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_4c3b4d81-aa02-4a70-bc1b-c04325716ec8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Chef‑Ready Kitchen",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_9c76de6f-0027-4bc0-b6b5-94c4e7c4552f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Coffee Nook*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_addbd9b5-567f-47c6-85f2-5873d0d959bf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Wood‑Vinyl and Carpeted Floors",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_50c72074-5d60-4e77-9cbf-dfd048c853d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Ceiling Fans with Decorative Light Kits in Living Areas and Bedrooms",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5636260c-ac42-41f2-8ca3-301fcd86599e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Renovated Homes with Modern LED Lighting*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1229601a-a06a-4d97-be92-d5635c57a03b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Coat Closet for Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7ce1b9c5-5088-4f73-8b8d-c1b2a61f4d75",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Expansive Walk‑In Closets",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_b91f1caf-abc9-440e-b242-b30b1a5d0bcd",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Garden‑Style Soaking Tubs with Curved Shower Rods",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_51460be8-155f-4dc0-89b9-1e0ccff5dc2f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "*Full‑Sized Washer and Dryer",
      "amount": "false",
      "description": "false",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_5b30d91b-8399-4fd5-b643-5984754c5480",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Gooseneck Faucet*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_7b061d51-0529-4170-a545-bf1614a5f1d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Outlets with USB Ports*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_1d09af22-e3e9-41b9-82cd-31fe3ca8f5fe",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "2” Faux Wood Blinds",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_025e9f47-c55c-4c88-84f5-fb678b016ebf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Loft Bonus Room*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_cf68210b-c530-41c8-b19a-974001d9837e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Private Patios and Balconies with Additional Storage",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_bf4743bb-206e-468a-90f6-d6c28f061b2c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "High‑Speed Internet Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_056a6f48-dbbe-4db3-91c2-f2c56e12f106",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Desirable Views Available*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_f6b4f52a-975f-4d88-a654-ad628bbb9fca",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Disability Access",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    },
    {
      "id": "custom_49b2870d-82e1-457f-adb8-7929eed7c3e9",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "external_id": "false",
      "title": "Attached Garage*",
      "amount": "false",
      "description": "",
      "group": "Apartment",
      "is_featured": "0",
      "amenity_image": null,
      "amenity_image_media": null,
      "amenity_image_alt_text": "false",
      "amenity_icon": null,
      "amenity_icon_media": null,
      "amenity_icon_alt_text": "false"
    }
  ],
  "photo_gallery": [
    {
      "id": "custom_71e952bb-d2ae-442a-876b-63e9586b8015",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d5c8-709f-94b8-1dbc995f1e71.webp",
      "image_media": {
        "alt_text": "Sparkling swimming pool with lounge chairs and umbrellas at an apartment complex.",
        "public_id": "01a0170f-d5c8-709f-94b8-1dbc995f1e71",
        "storage_key": "property/6767906449166922/01a0170f-d5c8-709f-94b8-1dbc995f1e71.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our stunning outdoor swimming pool, complete with comfortable lounge chairs and shaded umbrellas for ultimate relaxation.",
      "link": "",
      "alt_text": "Sparkling swimming pool with lounge chairs and umbrellas at an apartment complex.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_bf41f74b-ac98-4cd3-b5f2-41fa4be1b57d",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d204-71f8-9743-d38e5e1a7ea9.webp",
      "image_media": {
        "alt_text": "Swimming pool and lounge area with palm trees and apartment buildings in the background.",
        "public_id": "01a0170f-d204-71f8-9743-d38e5e1a7ea9",
        "storage_key": "property/6767906449166922/01a0170f-d204-71f8-9743-d38e5e1a7ea9.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Enjoy a refreshing dip in our sparkling swimming pool, surrounded by lush palm trees and comfortable lounge seating. Perfect for relaxing and soaking up the sun.",
      "link": "",
      "alt_text": "Swimming pool and lounge area with palm trees and apartment buildings in the background.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_3ca0e380-4b0e-4a3d-bc94-dcc9f295af28",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d2f0-70bf-88d1-5921fd026db1.webp",
      "image_media": {
        "alt_text": "Modern lounge area with a fireplace and comfortable seating.",
        "public_id": "01a0170f-d2f0-70bf-88d1-5921fd026db1",
        "storage_key": "property/6767906449166922/01a0170f-d2f0-70bf-88d1-5921fd026db1.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Community",
      "description": "Relax and unwind in the stylish community lounge, featuring a cozy fireplace and ample seating for socializing or quiet enjoyment.",
      "link": "",
      "alt_text": "Modern lounge area with a fireplace and comfortable seating.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_5dad47c7-3d97-4479-bab1-f4d6174943c9",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a035c3-f4f5-774d-a634-70d91375e499.webp",
      "image_media": {
        "alt_text": "Aura at Westchase fitness center with treadmills, elliptical machines, and weight machines.",
        "public_id": "01a035c3-f4f5-774d-a634-70d91375e499",
        "storage_key": "property/6767906449166922/01a035c3-f4f5-774d-a634-70d91375e499.webp",
        "width": 1529,
        "height": 1028
      },
      "title": "Community",
      "description": "Stay active in our state-of-the-art fitness center at Aura at Westchase, featuring a variety of cardio and strength training equipment.",
      "link": "",
      "alt_text": "Aura at Westchase fitness center with treadmills, elliptical machines, and weight machines.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_02fd85e2-848b-4481-ab30-07c6e8d8f34b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d202-7648-ba91-56b2340f6b02.webp",
      "image_media": {
        "alt_text": "Living room with blue sofa and leather armchair, open to kitchen and dining area.",
        "public_id": "01a0170f-d202-7648-ba91-56b2340f6b02",
        "storage_key": "property/6767906449166922/01a0170f-d202-7648-ba91-56b2340f6b02.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Spacious living room featuring a comfortable blue sofa and elegant leather armchair, seamlessly connected to a modern kitchen and dining space.",
      "link": "",
      "alt_text": "Living room with blue sofa and leather armchair, open to kitchen and dining area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_41062bae-148e-4e22-b946-d6a63c8ca23e",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d052-73d9-bd7b-88ad31f9387d.webp",
      "image_media": {
        "alt_text": "Modern kitchen with dark grey lower cabinets, white uppers, stainless steel appliances, and white quartz countertops.",
        "public_id": "01a0170f-d052-73d9-bd7b-88ad31f9387d",
        "storage_key": "property/6767906449166922/01a0170f-d052-73d9-bd7b-88ad31f9387d.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Enjoy cooking in this stylish kitchen, featuring modern dark grey and white cabinetry, stainless steel appliances, and elegant quartz countertops. Perfect for any home chef.",
      "link": "",
      "alt_text": "Modern kitchen with dark grey lower cabinets, white uppers, stainless steel appliances, and white quartz countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_34e45946-68d0-4866-a146-c5e54825cfe2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d42c-7491-9745-4f962cc88f44.webp",
      "image_media": {
        "alt_text": "Modern dining and kitchen area with island sink and stainless steel appliances.",
        "public_id": "01a0170f-d42c-7491-9745-4f962cc88f44",
        "storage_key": "property/6767906449166922/01a0170f-d42c-7491-9745-4f962cc88f44.webp",
        "width": 1531,
        "height": 1027
      },
      "title": "Apartment",
      "description": "Enjoy a spacious dining area adjacent to a modern kitchen, perfect for entertaining. Features a large island with a sink and contemporary finishes.",
      "link": "",
      "alt_text": "Modern dining and kitchen area with island sink and stainless steel appliances.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_ceffd80d-d23d-44da-a942-0de4d0661a16",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d4b3-715c-a49b-6ff3639dabf4.webp",
      "image_media": {
        "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a hallway leading to a bedroom.",
        "public_id": "01a0170f-d4b3-715c-a49b-6ff3639dabf4",
        "storage_key": "property/6767906449166922/01a0170f-d4b3-715c-a49b-6ff3639dabf4.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Step into a beautifully designed kitchen featuring sleek stainless steel appliances and ample cabinet space. This open-concept layout flows seamlessly into other living areas.",
      "link": "",
      "alt_text": "Modern kitchen with stainless steel appliances, white cabinets, and a hallway leading to a bedroom.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_b539dfcc-e64f-414f-9d2d-c7a5eee47616",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a03a25-0771-725f-b815-cba99759d47f.webp",
      "image_media": {
        "alt_text": "Modern kitchen and living room area with dark blue cabinets, stainless steel appliances, and light wood furniture.",
        "public_id": "01a03a25-0771-725f-b815-cba99759d47f",
        "storage_key": "property/6767906449166922/01a03a25-0771-725f-b815-cba99759d47f.webp",
        "width": 1527,
        "height": 1030
      },
      "title": "Apartment",
      "description": "Enjoy a spacious and modern living area featuring a well-equipped kitchen with dark blue cabinetry, stainless steel appliances, and a bright, open-concept living room.",
      "link": "",
      "alt_text": "Modern kitchen and living room area with dark blue cabinets, stainless steel appliances, and light wood furniture.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_33595c1d-4916-4b90-94c6-f43724eb9af5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d252-70f3-a7d4-5d81743cd273.webp",
      "image_media": {
        "alt_text": "Stylish bedroom with a king-size bed, modern nightstands, and a walk-in closet.",
        "public_id": "01a0170f-d252-70f3-a7d4-5d81743cd273",
        "storage_key": "property/6767906449166922/01a0170f-d252-70f3-a7d4-5d81743cd273.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Experience comfort and style in this beautifully appointed bedroom, featuring a plush king-size bed, elegant decor, and ample closet space.",
      "link": "",
      "alt_text": "Stylish bedroom with a king-size bed, modern nightstands, and a walk-in closet.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_6744899a-dd26-4112-bdcf-e26a1fdf4401",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a03a26-d370-71ad-afd1-24a2b93fe5f5.webp",
      "image_media": {
        "alt_text": "Bathroom vanity with double sinks, navy cabinets, and large mirrors.",
        "public_id": "01a03a26-d370-71ad-afd1-24a2b93fe5f5",
        "storage_key": "property/6767906449166922/01a03a26-d370-71ad-afd1-24a2b93fe5f5.webp",
        "width": 1530,
        "height": 1028
      },
      "title": "Apartment",
      "description": "Modern bathroom vanity featuring dual sinks, elegant navy blue cabinetry, and spacious countertops, perfect for a luxurious living experience.",
      "link": "",
      "alt_text": "Bathroom vanity with double sinks, navy cabinets, and large mirrors.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1aae2ff7-3424-465c-bf8f-fec2391f99ab",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a03a25-06fe-7110-9ba6-b15554adda79.webp",
      "image_media": {
        "alt_text": "A bright bedroom with a daybed, desk, and office chair.",
        "public_id": "01a03a25-06fe-7110-9ba6-b15554adda79",
        "storage_key": "property/6767906449166922/01a03a25-06fe-7110-9ba6-b15554adda79.webp",
        "width": 1528,
        "height": 1029
      },
      "title": "Apartment",
      "description": "This room features a comfortable daybed with a decorative throw, a modern desk with an office chair, and tasteful wall art.",
      "link": "",
      "alt_text": "A bright bedroom with a daybed, desk, and office chair.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_20cc2afa-2226-4407-88ce-eb4fe3488057",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-d466-715e-8b19-1027c5d0cd79.webp",
      "image_media": {
        "alt_text": "Modern kitchen with blue cabinets, white countertops, stainless steel appliances, and a view of the dining area and exterior.",
        "public_id": "01a0170f-d466-715e-8b19-1027c5d0cd79",
        "storage_key": "property/6767906449166922/01a0170f-d466-715e-8b19-1027c5d0cd79.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Stunning kitchen featuring dark blue cabinetry, white quartz countertops, and stainless steel appliances. Enjoy the open layout with a dining area perfect for entertaining.",
      "link": "",
      "alt_text": "Modern kitchen with blue cabinets, white countertops, stainless steel appliances, and a view of the dining area and exterior.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_e9978fcd-cfe3-4d16-89f2-e3ec7d46cceb",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a035c3-f799-7369-8707-b93046778a9b.webp",
      "image_media": {
        "alt_text": "Apartment patio with seating and plants",
        "public_id": "01a035c3-f799-7369-8707-b93046778a9b",
        "storage_key": "property/6767906449166922/01a035c3-f799-7369-8707-b93046778a9b.webp",
        "width": 1535,
        "height": 1025
      },
      "title": "Apartment",
      "description": "Enjoy outdoor living on your private patio, complete with comfortable seating and lush greenery.",
      "link": "",
      "alt_text": "Apartment patio with seating and plants",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_c4933027-4415-4ab5-a309-e5bf7f1387aa",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-e2a5-7343-917d-53c41d9b0a91.webp",
      "image_media": {
        "alt_text": "Modern kitchen with navy blue cabinets and white countertops.",
        "public_id": "01a0170f-e2a5-7343-917d-53c41d9b0a91",
        "storage_key": "property/6767906449166922/01a0170f-e2a5-7343-917d-53c41d9b0a91.webp",
        "width": 1535,
        "height": 1024
      },
      "title": "Apartment",
      "description": "A stylish kitchen featuring navy blue lower cabinets, white upper cabinets, stainless steel appliances, and a sleek undermount sink.",
      "link": "",
      "alt_text": "Modern kitchen with navy blue cabinets and white countertops.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_efa54156-831a-4914-aed6-927672b8c581",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-e0f8-77cf-83cd-cb97f58ca71a.webp",
      "image_media": {
        "alt_text": "Chic bedroom with king-sized bed, plush bedding, and modern decor.",
        "public_id": "01a0170f-e0f8-77cf-83cd-cb97f58ca71a",
        "storage_key": "property/6767906449166922/01a0170f-e0f8-77cf-83cd-cb97f58ca71a.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Step into comfort in this beautifully appointed bedroom, featuring a plush king-sized bed and sophisticated decor. Perfect for relaxation.",
      "link": "",
      "alt_text": "Chic bedroom with king-sized bed, plush bedding, and modern decor.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_0fa933d4-e650-4de0-81da-1296b60a11c4",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-e2a5-7343-917d-4daf32772791.webp",
      "image_media": {
        "alt_text": "Modern bathroom with navy blue vanity, white countertops, and a black framed mirror.",
        "public_id": "01a0170f-e2a5-7343-917d-4daf32772791",
        "storage_key": "property/6767906449166922/01a0170f-e2a5-7343-917d-4daf32772791.webp",
        "width": 1536,
        "height": 1024
      },
      "title": "Apartment",
      "description": "Bright and modern apartment bathroom featuring a stylish navy blue vanity, white quartz countertops, and a large black framed mirror, perfect for everyday living.",
      "link": "",
      "alt_text": "Modern bathroom with navy blue vanity, white countertops, and a black framed mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1d950872-abbd-4858-94ea-e91d09e153bd",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/01a0170f-cfba-720d-8c34-61b3d6e9fedf.webp",
      "image_media": {
        "alt_text": "Modern bathroom with dark blue vanity, white countertop, and large black-framed mirror.",
        "public_id": "01a0170f-cfba-720d-8c34-61b3d6e9fedf",
        "storage_key": "property/6767906449166922/01a0170f-cfba-720d-8c34-61b3d6e9fedf.webp",
        "width": 1537,
        "height": 1023
      },
      "title": "Apartment",
      "description": "Step into this stylish bathroom featuring a spacious vanity with ample storage, a sleek countertop, and a large mirror for a touch of elegance. Perfect for unwinding.",
      "link": "",
      "alt_text": "Modern bathroom with dark blue vanity, white countertop, and large black-framed mirror.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_53a0ce8f-68ce-4058-a433-02245597831b",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019e60cc-dc46-703c-87b5-62997faf68e8.webp",
      "image_media": {
        "alt_text": "Exterior view of the building entrance with a fountain and landscaped grounds.",
        "public_id": "019e60cc-dc46-703c-87b5-62997faf68e8",
        "storage_key": "property/6767906449166922/019e60cc-dc46-703c-87b5-62997faf68e8.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Elegant building entrance featuring a fountain, manicured landscaping, and architectural details, offering a welcoming first impression.",
      "link": "",
      "alt_text": "Exterior view of the building entrance with a fountain and landscaped grounds.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    },
    {
      "id": "custom_1f2c2581-f347-4f7e-9087-acc405b3acf6",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019e60cc-dc4e-7119-824e-eccaf62fd6b6.webp",
      "image_media": {
        "alt_text": "Apartment complex courtyard with a swimming pool and seating area.",
        "public_id": "019e60cc-dc4e-7119-824e-eccaf62fd6b6",
        "storage_key": "property/6767906449166922/019e60cc-dc4e-7119-824e-eccaf62fd6b6.webp",
        "width": 3072,
        "height": 2050
      },
      "title": "Community",
      "description": "Relax and unwind by the sparkling swimming pool, surrounded by lush landscaping and modern apartment buildings.",
      "link": "",
      "alt_text": "Apartment complex courtyard with a swimming pool and seating area.",
      "link_text": "",
      "source_page_urls": "false",
      "original_url": ""
    }
  ],
  "neighborhood_pois": [
    {
      "id": "custom_dc185b84-55da-43f3-aa65-f9781a686b72",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Kasra Persian Grill",
      "poi_type": "Restaurants",
      "poi_address": "9741 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Modest family-run spot hidden in a strip mall serves large portions of homey Middle Eastern cuisine.",
      "poi_long_description": "Modest family-run spot hidden in a strip mall serves large portions of homey Middle Eastern cuisine.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-ed6a-7230-9a38-9064d45e18b8.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-ed6a-7230-9a38-9064d45e18b8",
        "storage_key": "property/6767906449166922/019d08b0-ed6a-7230-9a38-9064d45e18b8.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.kasrarestaurants.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1850883766217975803&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kasra-persian-grill",
      "poi_latitude": "29.736085",
      "poi_longitude": "-95.540949",
      "poi_miles_from_property": "2.4",
      "poi_walking_minutes": "55 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-975-1810",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJx9GB-T3DQIYR-6f1nfqorxk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "persian_restaurant"
    },
    {
      "id": "custom_84150db3-e654-4d4c-8978-a0ae7cc9b2b4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Avesta Persian Middle Eastern",
      "poi_type": "Restaurants",
      "poi_address": "11165 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Strip-mall storefront offering Middle Eastern cuisine like stews & kebabs in modest environs.",
      "poi_long_description": "Strip-mall storefront offering Middle Eastern cuisine like stews & kebabs in modest environs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-4baa-704f-a9cb-d99c074334ef.webp",
      "poi_featured_image_media": {
        "alt_text": "A long dining table set for a meal with bottles of water and plates.",
        "public_id": "019db17d-4baa-704f-a9cb-d99c074334ef",
        "storage_key": "property/6767906449166922/019db17d-4baa-704f-a9cb-d99c074334ef.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.avestahouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3154407663395890618&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "avesta-persian-middle-eastern",
      "poi_latitude": "29.7355678",
      "poi_longitude": "-95.5729048",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 713-781-5555",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-5rPUs_cQIYRumV7nQ61xis",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "persian_restaurant"
    },
    {
      "id": "custom_adacaad5-1f4e-4309-a033-be4eb6eabc2d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Bistro Le Cep",
      "poi_type": "Restaurants",
      "poi_address": "11112 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Petite eatery serving country-style French bistro cuisine in a homey, rustic environment.",
      "poi_long_description": "Petite eatery serving country-style French bistro cuisine in a homey, rustic environment.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-f571-773d-8f12-ca41e3e40e32.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-f571-773d-8f12-ca41e3e40e32",
        "storage_key": "property/6767906449166922/019d08b0-f571-773d-8f12-ca41e3e40e32.webp",
        "width": 1280,
        "height": 850
      },
      "poi_business_url": "http://www.bistro-le-cep.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7056232360421346813&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bistro-le-cep",
      "poi_latitude": "29.7370153",
      "poi_longitude": "-95.5730005",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-783-3985",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ-6puJMbcQIYR_c2HP_LF7GE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "french_restaurant"
    },
    {
      "id": "custom_d0f9d808-9606-4622-a422-4a24fc369186",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Rio Ranch Restaurant",
      "poi_type": "Restaurants",
      "poi_address": "9999 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Charming steakhouse inside the Hilton hotel with ranch-house decor & a man-made creek off the patio.",
      "poi_long_description": "Charming steakhouse inside the Hilton hotel with ranch-house decor & a man-made creek off the patio.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-e9b6-76d5-8efb-a8bec3fa2c43.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e9b6-76d5-8efb-a8bec3fa2c43",
        "storage_key": "property/6767906449166922/019d08b0-e9b6-76d5-8efb-a8bec3fa2c43.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://www.rioranch.com/?utm_source=google&utm_medium=organic&utm_campaign=gbp_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=10543778970119743060&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rio-ranch-restaurant",
      "poi_latitude": "29.7361857",
      "poi_longitude": "-95.5467169",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-952-5000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJA7KF4TvDQIYRVKY4KBwHU5I",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_6ca3bcde-d7d1-42a2-8d28-dbd62cce7575",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Pappas Bar-B-Q",
      "poi_type": "Restaurants",
      "poi_address": "9797 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Long-standing chain dishing up Texas-style smoked meats & sides in a relaxed counter-serve setting.",
      "poi_long_description": "Long-standing chain dishing up Texas-style smoked meats & sides in a relaxed counter-serve setting.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-337e-706c-a3e6-7ae8c96f0a36.webp",
      "poi_featured_image_media": {
        "alt_text": "A hallway with wood-paneled walls, hanging plants, and a non-smoking area sign.",
        "public_id": "019db17d-337e-706c-a3e6-7ae8c96f0a36",
        "storage_key": "property/6767906449166922/019db17d-337e-706c-a3e6-7ae8c96f0a36.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://pappasbbq.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15154864734940312125&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pappas-bar-b-q",
      "poi_latitude": "29.7357728",
      "poi_longitude": "-95.5396274",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "57 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-780-0081",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJN03qGxbDQIYRPTI2uS7lUNI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "barbecue_restaurant"
    },
    {
      "id": "custom_fc249f91-b355-4091-83a1-8b475a764765",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Feng Ling",
      "poi_type": "Restaurants",
      "poi_address": "11010 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Enduring eatery with a laid-back vibe offering Hunan & Sichuan cuisine for dine-in or takeout.",
      "poi_long_description": "Enduring eatery with a laid-back vibe offering Hunan & Sichuan cuisine for dine-in or takeout.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-3e11-75e0-a10b-c622c8b1b434.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of Feng Ling Restaurant building with cars parked in front.",
        "public_id": "019db17d-3e11-75e0-a10b-c622c8b1b434",
        "storage_key": "property/6767906449166922/019db17d-3e11-75e0-a10b-c622c8b1b434.webp",
        "width": 3072,
        "height": 2300
      },
      "poi_business_url": "https://www.fenglingrestauranttx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8863270064692148582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "feng-ling",
      "poi_latitude": "29.7379086",
      "poi_longitude": "-95.5709865",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-782-3144",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJZc08w8jcQIYRZjlUCiqpAHs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_e5a084a0-bb13-447b-9b32-5b6410e86a4f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Desi District Restaurant, Bar & Banquets",
      "poi_type": "Restaurants",
      "poi_address": "11129 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Casual eatery dishing up Indian comfort food from quick bites to all-you-can-eat options, plus cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-3243-717c-8761-a7a94a69eebf.webp",
      "poi_featured_image_media": {
        "alt_text": "Bar and dining area with tables, chairs, and a large bar.",
        "public_id": "019db17d-3243-717c-8761-a7a94a69eebf",
        "storage_key": "property/6767906449166922/019db17d-3243-717c-8761-a7a94a69eebf.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "http://www.desidistrict.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16940812844230165032&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "desi-district-restaurant-bar--banquets",
      "poi_latitude": "29.7346252",
      "poi_longitude": "-95.5721067",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 346-681-3374",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJfX44aHHdQIYRKMK2iobbGes",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "indian_restaurant"
    },
    {
      "id": "custom_1fe537d1-137a-47b8-9504-be14fa37906a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "The Original Marini's Empanada House",
      "poi_type": "Restaurants",
      "poi_address": "10001 Westheimer Rd # 2570, Houston, TX 77042, USA",
      "poi_short_description": "Empanadas are fried to order with a variety of savory & sweet fillings at this counter-serve spot.",
      "poi_long_description": "Empanadas are fried to order with a variety of savory & sweet fillings at this counter-serve spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-308b-7681-a691-7b722496cb15.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Marini's Empanada House with a palm tree and landscaping.",
        "public_id": "019db17d-308b-7681-a691-7b722496cb15",
        "storage_key": "property/6767906449166922/019db17d-308b-7681-a691-7b722496cb15.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.theoriginalmarinis.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17656435731278150949&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-original-marinis-empanada-house",
      "poi_latitude": "29.7362684",
      "poi_longitude": "-95.5503699",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-266-2729",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQuMGjrDQIYRJT1Z8r9CCPU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "argentinian_restaurant"
    },
    {
      "id": "custom_44d6d720-6841-4e34-9020-03cc2a6b4ccb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Fornos",
      "poi_type": "Restaurants",
      "poi_address": "10001 Westheimer Rd #1202, Houston, TX 77042, USA",
      "poi_short_description": "Spacious eatery serving classic Italian food in a homey setting with old-world murals & knickknacks.",
      "poi_long_description": "Spacious eatery serving classic Italian food in a homey setting with old-world murals & knickknacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-308f-71d8-8bff-42c0213800ee.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of the Fornos Italian restaurant at night.",
        "public_id": "019db17d-308f-71d8-8bff-42c0213800ee",
        "storage_key": "property/6767906449166922/019db17d-308f-71d8-8bff-42c0213800ee.webp",
        "width": 3072,
        "height": 1384
      },
      "poi_business_url": "https://www.fornosofitalytx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=14215608212800194412&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "fornos",
      "poi_latitude": "29.7356591",
      "poi_longitude": "-95.5497878",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-789-5552",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJyQuMGjrDQIYRbMcUHlr8R8U",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "italian_restaurant"
    },
    {
      "id": "custom_d108eaf3-2daf-4c26-8d46-2dac92279538",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Pacha Nikkei",
      "poi_type": "Restaurants",
      "poi_address": "10001 Westheimer Rd Suite 5, Houston, TX 77042, USA",
      "poi_short_description": "Casual eatery serving up Japanese and Peruvian-influenced dishes like ceviche and sushi, plus cocktails.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-e3b5-700b-a8b1-85bdd7e625ef.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e3b5-700b-a8b1-85bdd7e625ef",
        "storage_key": "property/6767906449166922/019d08b0-e3b5-700b-a8b1-85bdd7e625ef.webp",
        "width": 1200,
        "height": 900
      },
      "poi_business_url": "https://www.pachanikkei.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1455288325308636450&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pacha-nikkei",
      "poi_latitude": "29.7365575",
      "poi_longitude": "-95.549826",
      "poi_miles_from_property": "1.9",
      "poi_walking_minutes": "43 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 832-834-5697",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJk6AkGbXBQIYRIl3LewU5MhQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "peruvian_restaurant"
    },
    {
      "id": "custom_cf8671a7-4956-4df2-91d6-7547a5764043",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Kura Revolving Sushi Bar",
      "poi_type": "Restaurants",
      "poi_address": "11161 Westheimer Rd Suite B, Houston, TX 77042, USA",
      "poi_short_description": "An array of sushi & other Japanese dishes drifts past diners on a conveyor belt at this simple spot.",
      "poi_long_description": "An array of sushi & other Japanese dishes drifts past diners on a conveyor belt at this simple spot.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-e708-716f-9c9d-3566902d0154.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b0-e708-716f-9c9d-3566902d0154",
        "storage_key": "property/6767906449166922/019d08b0-e708-716f-9c9d-3566902d0154.webp",
        "width": 1280,
        "height": 853
      },
      "poi_business_url": "https://kurasushi.com/locations/houston-tx-westchase/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11367097617482365816&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kura-revolving-sushi-bar",
      "poi_latitude": "29.7355087",
      "poi_longitude": "-95.5728937",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "2 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-767-5208",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9S5b48XcQIYReLs5wQ4LwJ0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sushi_restaurant"
    },
    {
      "id": "custom_6676cdcc-fdb8-4156-badd-f92b35693237",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "W Kitchen",
      "poi_type": "Restaurants",
      "poi_address": "10928 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Informal strip-mall restaurant offering draft beer & generous plates of classic Chinese fare.",
      "poi_long_description": "Informal strip-mall restaurant offering draft beer & generous plates of classic Chinese fare.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-4b45-711f-b9cd-52278ed55348.webp",
      "poi_featured_image_media": {
        "alt_text": "W Kitchen Chinese Restaurant exterior signage at night",
        "public_id": "019db17d-4b45-711f-b9cd-52278ed55348",
        "storage_key": "property/6767906449166922/019db17d-4b45-711f-b9cd-52278ed55348.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://wkitchenhtx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16224291091525338082&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "w-kitchen",
      "poi_latitude": "29.7378556",
      "poi_longitude": "-95.5690615",
      "poi_miles_from_property": "0.8",
      "poi_walking_minutes": "18 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-388-2288",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJe0h9nvbdQIYR4gPnqslCKOE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "chinese_restaurant"
    },
    {
      "id": "custom_cec7753a-2249-469a-a921-838679c58323",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Pho One",
      "poi_type": "Restaurants",
      "poi_address": "11148 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Family-run eatery preparing Vietnamese noodle soups, sandwiches & spring rolls in simple surrounds.",
      "poi_long_description": "Family-run eatery preparing Vietnamese noodle soups, sandwiches & spring rolls in simple surrounds.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-37b3-72fa-b675-b7a807430d9a.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a restaurant dining area with tables and chairs.",
        "public_id": "019db17d-37b3-72fa-b675-b7a807430d9a",
        "storage_key": "property/6767906449166922/019db17d-37b3-72fa-b675-b7a807430d9a.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.phoonehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2326691615162634976&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "pho-one",
      "poi_latitude": "29.7376705",
      "poi_longitude": "-95.5723186",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-917-0351",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJr3ynFcbcQIYR4BKmV7IRSiA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "vietnamese_restaurant"
    },
    {
      "id": "custom_16f3485e-4c66-4576-83de-5e6a8898ae11",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Dakar Street Food",
      "poi_type": "Restaurants",
      "poi_address": "2923 Walnut Bend Ln, Houston, TX 77042, USA",
      "poi_short_description": "Casual, Senegalese spot specializing in regional specialties such as rice and lamb dishes served with various sauces.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-4b5a-74e8-9104-49f1ca5a7b66.webp",
      "poi_featured_image_media": {
        "alt_text": "A storefront with a sign for \"Boran Street Food\" and an advertisement for a liquor store.",
        "public_id": "019db17d-4b5a-74e8-9104-49f1ca5a7b66",
        "storage_key": "property/6767906449166922/019db17d-4b5a-74e8-9104-49f1ca5a7b66.webp",
        "width": 2461,
        "height": 1600
      },
      "poi_business_url": "https://dakarstreetfood.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18360746553509322267&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dakar-street-food",
      "poi_latitude": "29.7319017",
      "poi_longitude": "-95.5672003",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 281-846-6420",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5XGosm3dQIYRG57mBLZ5zv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_a3b3d958-ce03-4588-87a1-e3ae423e56ff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Los Tios",
      "poi_type": "Restaurants",
      "poi_address": "9527 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Outpost of a casual local chain eatery serving Mexican & Tex-Mex favorites & margaritas since 1970.",
      "poi_long_description": "Outpost of a casual local chain eatery serving Mexican & Tex-Mex favorites & margaritas since 1970.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-57da-7392-93f9-5e22b77850ab.webp",
      "poi_featured_image_media": {
        "alt_text": "Restaurant interior with tables and a bar area.",
        "public_id": "019db17d-57da-7392-93f9-5e22b77850ab",
        "storage_key": "property/6767906449166922/019db17d-57da-7392-93f9-5e22b77850ab.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.lostiosrestaurant.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5407175210560391545&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "los-tios",
      "poi_latitude": "29.7362315",
      "poi_longitude": "-95.5341587",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-784-0380",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJEx8DgBHDQIYReQnAnzQlCks",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_58b112fb-bbe2-4ede-9aae-aba81399155f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Whole Foods Market",
      "poi_type": "Shopping & Retail",
      "poi_address": "11041 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_long_description": "Eco-minded chain with natural & organic grocery items, housewares & other products (most sell wine).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-5979-753c-9832-af21cce546ff.webp",
      "poi_featured_image_media": {
        "alt_text": "Whole Foods Market and adjacent Petco store exterior with parking lot",
        "public_id": "019db17d-5979-753c-9832-af21cce546ff",
        "storage_key": "property/6767906449166922/019db17d-5979-753c-9832-af21cce546ff.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.wholefoodsmarket.com/stores/westchase?utm_source=google&utm_medium=organic&utm_campaign=listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=16452124438804102209&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "whole-foods-market",
      "poi_latitude": "29.7348965",
      "poi_longitude": "-95.5706292",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-784-7776",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da",
        "storage_key": "property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJbVjVG8bcQIYRQfxwjwKwUeQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_3adee29c-abcb-4fc0-82a2-35b2b5096588",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Market at Westchase",
      "poi_type": "Shopping & Retail",
      "poi_address": "11129 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Shopping mall offering a variety of stores, including a gym, a grocery store, and a Mexican restaurant.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-6768-72fd-a173-f3b6f328d187.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a CVS pharmacy and Starbucks storefront with a parking lot.",
        "public_id": "019db17d-6768-72fd-a173-f3b6f328d187",
        "storage_key": "property/6767906449166922/019db17d-6768-72fd-a173-f3b6f328d187.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.jblmgmt.com/market-at-westchase",
      "poi_directions_map_url": "https://maps.google.com/?cid=3941320872725563781&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "market-at-westchase",
      "poi_latitude": "29.7346227",
      "poi_longitude": "-95.572126",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "11 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fb7-71ba-9b79-7c90a71e8f16",
        "storage_key": "property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ87qo_cXcQIYRhcmjpHNisjY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_63e55379-33fc-481c-bf4a-e78dc499393e",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Daido Market Houston",
      "poi_type": "Shopping & Retail",
      "poi_address": "11146 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Local supermarket stocking produce & sushi-grade fish alongside imported Japanese foodstuffs.",
      "poi_long_description": "Local supermarket stocking produce & sushi-grade fish alongside imported Japanese foodstuffs.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-6712-7567-92f7-3e2912655cef.webp",
      "poi_featured_image_media": {
        "alt_text": "Nippan Daido store exterior with parking lot and cars.",
        "public_id": "019db17d-6712-7567-92f7-3e2912655cef",
        "storage_key": "property/6767906449166922/019db17d-6712-7567-92f7-3e2912655cef.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.daidotx.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15597625568930771507&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daido-market-houston",
      "poi_latitude": "29.7376632",
      "poi_longitude": "-95.572525",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "13 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-785-0815",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da",
        "storage_key": "property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJB42mFcbcQIYRMzKrr9Dlddg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "asian_grocery_store"
    },
    {
      "id": "custom_fa5d2de6-f1df-47b4-9bfc-99361781aaff",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Daiso - Japanese Household Goods",
      "poi_type": "Shopping & Retail",
      "poi_address": "11151 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Japanese variety-store chain featuring Japanese beauty products, housewares & snacks.",
      "poi_long_description": "Japanese variety-store chain featuring Japanese beauty products, housewares & snacks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-5b01-70b9-84e2-8a16cde0422b.webp",
      "poi_featured_image_media": {
        "alt_text": "Daiso storefront exterior with large windows and parking lot.",
        "public_id": "019db17d-5b01-70b9-84e2-8a16cde0422b",
        "storage_key": "property/6767906449166922/019db17d-5b01-70b9-84e2-8a16cde0422b.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://daisous.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4868553640172921184&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "daiso---japanese-household-goods",
      "poi_latitude": "29.7350851",
      "poi_longitude": "-95.5729682",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-703-1146",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fb7-71ba-9b79-7c90a71e8f16",
        "storage_key": "property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJi4eB6SfdQIYRYCFxtL2TkEM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "home_goods_store"
    },
    {
      "id": "custom_f57c8d60-78d4-4c2a-af68-2b615973ad45",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Trader Joe's",
      "poi_type": "Shopping & Retail",
      "poi_address": "11683 Westheimer Rd, Houston, TX 77077, USA",
      "poi_short_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_long_description": "Grocery chain with a variety of signature items, plus produce, dairy & more (most sell wine & beer).",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-6706-74d1-b77c-1d7ddd332861.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Trader Joe's grocery store with orange and stone facade.",
        "public_id": "019db17d-6706-74d1-b77c-1d7ddd332861",
        "storage_key": "property/6767906449166922/019db17d-6706-74d1-b77c-1d7ddd332861.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://locations.traderjoes.com/tx/houston/431/?utm_source=gmb&utm_medium=organic&utm_campaign=local",
      "poi_directions_map_url": "https://maps.google.com/?cid=2636626803521818376&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "trader-joes",
      "poi_latitude": "29.7354063",
      "poi_longitude": "-95.5824872",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 281-496-2488",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da",
        "storage_key": "property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJmb9cC-rcQIYRCA8xvRsulyQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_f548d97a-7bff-4b9f-a3e7-2befd12e43f5",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Target",
      "poi_type": "Shopping & Retail",
      "poi_address": "10801 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_long_description": "Retail chain offering home goods, clothing, electronics & more, plus exclusive designer collections.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-097b-71cd-ac57-f2b3b0122e1e.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-097b-71cd-ac57-f2b3b0122e1e",
        "storage_key": "property/6767906449166922/019d08b1-097b-71cd-ac57-f2b3b0122e1e.webp",
        "width": 1280,
        "height": 715
      },
      "poi_business_url": "https://www.target.com/sl/houston-westchase/75",
      "poi_directions_map_url": "https://maps.google.com/?cid=11990776882479516189&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "target",
      "poi_latitude": "29.7349897",
      "poi_longitude": "-95.5678231",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-782-9950",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fb7-71ba-9b79-7c90a71e8f16",
        "storage_key": "property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ7XTKs87cQIYRHUoodQvMZ6Y",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "department_store"
    },
    {
      "id": "custom_56f8acac-325d-4157-836e-f149e5ccaa76",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Kroger",
      "poi_type": "Shopping & Retail",
      "poi_address": "9919 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_long_description": "Large supermarket chain with deli & bakery departments, plus health & beauty products.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-795c-750c-afce-44fd40919655.webp",
      "poi_featured_image_media": {
        "alt_text": "Kroger grocery store exterior with signage and pharmacy entrance.",
        "public_id": "019db17d-795c-750c-afce-44fd40919655",
        "storage_key": "property/6767906449166922/019db17d-795c-750c-afce-44fd40919655.webp",
        "width": 480,
        "height": 270
      },
      "poi_business_url": "https://www.kroger.com/stores/grocery/tx/houston/elmside/034/00363?cid=loc_03400363_gmb",
      "poi_directions_map_url": "https://maps.google.com/?cid=11055500868287114152&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kroger",
      "poi_latitude": "29.7363167",
      "poi_longitude": "-95.5452526",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-532-5566",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da",
        "storage_key": "property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ0_kj8TvDQIYRqKtGFHcHbZk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_05412d3e-dd54-4bd9-a881-f25e5164a67b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Randalls",
      "poi_type": "Shopping & Retail",
      "poi_address": "9660 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Grocery store chain supplying produce, baked goods, meats, and other essentials, plus a deli and a pharmacy.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-7bbe-70ef-8f27-67052b12362c.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a Randalls grocery store with cars parked in the lot.",
        "public_id": "019db17d-7bbe-70ef-8f27-67052b12362c",
        "storage_key": "property/6767906449166922/019db17d-7bbe-70ef-8f27-67052b12362c.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://local.randalls.com/tx/houston/9660-westheimer-rd.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=12171927843379335079&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "randalls",
      "poi_latitude": "29.7387246",
      "poi_longitude": "-95.5369829",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "24 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-782-0982",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da",
        "storage_key": "property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJdZM9JhTDQIYRp89PSOJf66g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_8dcf8cfb-63e6-4501-bc42-74c4fbf0cc9c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Petco",
      "poi_type": "Shopping & Retail",
      "poi_address": "10911 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_long_description": "Chain with pet food & supplies such as toys, beds & pet technology products, plus medication.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-7dae-719f-b9e0-ebf6a419dac2.webp",
      "poi_featured_image_media": {
        "alt_text": "Couple with dog walking outside Petco with a bag of dog food.",
        "public_id": "019db17d-7dae-719f-b9e0-ebf6a419dac2",
        "storage_key": "property/6767906449166922/019db17d-7dae-719f-b9e0-ebf6a419dac2.webp",
        "width": 1359,
        "height": 1086
      },
      "poi_business_url": "https://stores.petco.com/tx/houston/pet-supplies-houston-tx-1449.html",
      "poi_directions_map_url": "https://maps.google.com/?cid=3366808295245937031&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petco",
      "poi_latitude": "29.7350458",
      "poi_longitude": "-95.5700445",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "15 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-972-1244",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fb7-71ba-9b79-7c90a71e8f16",
        "storage_key": "property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJcX_UyXXdQIYRh_n4cE5OuS4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pet_store"
    },
    {
      "id": "custom_25c00825-d690-4508-90c3-3f60a0b4b8f3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Food Town",
      "poi_type": "Shopping & Retail",
      "poi_address": "1455 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Supermarket chain stocking meats & produce, plus a full selection of basic groceries.",
      "poi_long_description": "Supermarket chain stocking meats & produce, plus a full selection of basic groceries.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-81f7-7219-9619-47b675c72408.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of a Food Towin grocery store with a parking lot and several cars.",
        "public_id": "019db17d-81f7-7219-9619-47b675c72408",
        "storage_key": "property/6767906449166922/019db17d-81f7-7219-9619-47b675c72408.webp",
        "width": 2119,
        "height": 1192
      },
      "poi_business_url": "https://www.yourfoodtown.com/store/food-town-houston-wilcrest-206/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3398882602969853342&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "food-town",
      "poi_latitude": "29.7485234",
      "poi_longitude": "-95.5708349",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "9 mins",
      "poi_driving_minutes": "5 mins",
      "poi_business_phone": "+1 713-781-5295",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da",
        "storage_key": "property/6767906449166922/019d08b1-7fa7-745b-8f5b-8ea9c6c8c1da.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJLaUkvrDcQIYRnu1FJ7hBKy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "grocery_store"
    },
    {
      "id": "custom_93a97620-49bd-4bf6-8b52-1e46018c1942",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Alief Early College High School",
      "poi_type": "Education",
      "poi_address": "2811 Hayes Rd, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-801a-709a-bb77-8c64f48db444.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of Early College High School entrance and courtyard with picnic tables.",
        "public_id": "019db17d-801a-709a-bb77-8c64f48db444",
        "storage_key": "property/6767906449166922/019db17d-801a-709a-bb77-8c64f48db444.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://aechs.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13752786820980316568&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "alief-early-college-high-school",
      "poi_latitude": "29.7335587",
      "poi_longitude": "-95.5748878",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 281-988-3010",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJB67ol8bcQIYRmJk0kL-2274",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_de4b2f5a-6358-4176-be2e-879f8195ef3c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Houston City College - Alief Hayes Campus",
      "poi_type": "Education",
      "poi_address": "2811 Hayes Rd, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db179-18a7-7661-a852-2f225d016ea8.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior view of a multi-story building with a glass ceiling, showing walkways, offices, and a seating area.",
        "public_id": "019db179-18a7-7661-a852-2f225d016ea8",
        "storage_key": "property/6767906449166922/019db179-18a7-7661-a852-2f225d016ea8.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.hccs.edu/locations/northwest-college/alief-hayes-campus/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7626777246185878854&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---alief-hayes-campus",
      "poi_latitude": "29.7336019",
      "poi_longitude": "-95.5748367",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "8 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 713-718-2339",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJD2aIxsXcQIYRRvXwO3_B12k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    },
    {
      "id": "custom_9f830cff-df0e-4ad8-8e0a-ae585f95206b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Holmquist Elementary School",
      "poi_type": "Education",
      "poi_address": "15040 Westpark Dr, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-1adf-72d9-b204-961b76a19550.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-1adf-72d9-b204-961b76a19550",
        "storage_key": "property/6767906449166922/019d08b1-1adf-72d9-b204-961b76a19550.webp",
        "width": 1280,
        "height": 897
      },
      "poi_business_url": "http://holmquist.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=436995191329294387&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "holmquist-elementary-school",
      "poi_latitude": "29.7185283",
      "poi_longitude": "-95.6574024",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 24 mins",
      "poi_biking_minutes": "37 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 281-988-3024",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJVXYpV4jeQIYRM4i8q8-EEAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_541d7f1a-4dd0-44e7-95df-6039c398292b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Rees Elementary School",
      "poi_type": "Education",
      "poi_address": "16305 Kensley Dr, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-91fe-7539-a423-83c1974eb615.webp",
      "poi_featured_image_media": {
        "alt_text": "A group of diverse young girls posing for a photo, some wearing name tags.",
        "public_id": "019db17d-91fe-7539-a423-83c1974eb615",
        "storage_key": "property/6767906449166922/019db17d-91fe-7539-a423-83c1974eb615.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://rees.aliefisd.net/o/rees",
      "poi_directions_map_url": "https://maps.google.com/?cid=11547265886868455842&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "rees-elementary-school",
      "poi_latitude": "29.712889",
      "poi_longitude": "-95.6745845",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 49 mins",
      "poi_biking_minutes": "43 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-531-1444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJO74tm1jeQIYRosHH4SQhQKA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_94ee130b-9416-43b4-9ff8-32e86be906ee",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Sneed Elementary School",
      "poi_type": "Education",
      "poi_address": "9855 Pagewood Ln, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "http://sneed.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=18356224938724685907&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "sneed-elementary-school",
      "poi_latitude": "29.7247712",
      "poi_longitude": "-95.5447465",
      "poi_miles_from_property": "2.5",
      "poi_walking_minutes": "58 mins",
      "poi_biking_minutes": "16 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-789-6979",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJV1pReyHDQIYRU_jZiVNpvv4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "primary_school"
    },
    {
      "id": "custom_730213eb-181d-4384-8483-a412e1f4dd33",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Budewig Intermediate School",
      "poi_type": "Education",
      "poi_address": "12570 Richmond Ave, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-8961-7669-9aa8-c2820d96e013.webp",
      "poi_featured_image_media": {
        "alt_text": "Budewig Intermediate school sign",
        "public_id": "019db17d-8961-7669-9aa8-c2820d96e013",
        "storage_key": "property/6767906449166922/019db17d-8961-7669-9aa8-c2820d96e013.webp",
        "width": 1932,
        "height": 2576
      },
      "poi_business_url": "http://www.aliefisd.net/budewig",
      "poi_directions_map_url": "https://maps.google.com/?cid=2454665876387196895&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "budewig-intermediate-school",
      "poi_latitude": "29.7312869",
      "poi_longitude": "-95.6038514",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "13 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-988-3200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJFeS0f1jcQIYR3-9U9Ju5ECI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_97f65156-f791-4269-a768-b7c856192a7f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "O'Donnell Middle School",
      "poi_type": "Education",
      "poi_address": "14041 Alief Clodine Rd, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-89c3-75ca-8246-6ad8864ebc29.webp",
      "poi_featured_image_media": {
        "alt_text": "School cafeteria with tables and benches, sunlight streaming through windows.",
        "public_id": "019db17d-89c3-75ca-8246-6ad8864ebc29",
        "storage_key": "property/6767906449166922/019db17d-89c3-75ca-8246-6ad8864ebc29.webp",
        "width": 1920,
        "height": 2560
      },
      "poi_business_url": "http://odonnell.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17404444510136050643&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "odonnell-middle-school",
      "poi_latitude": "29.7100972",
      "poi_longitude": "-95.6333472",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 57 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-495-6000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJjd5N2c3dQIYR0yOouxECifE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "school"
    },
    {
      "id": "custom_9d0b1776-2d5c-4c34-8a8d-854a284cb200",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Elsik High School",
      "poi_type": "Education",
      "poi_address": "12601 High Star Dr, Houston, TX 77072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-81af-7246-8eea-b20d09a18f73.webp",
      "poi_featured_image_media": {
        "alt_text": "Elsisk High School monument sign with winter break dates and student holiday.",
        "public_id": "019db17d-81af-7246-8eea-b20d09a18f73",
        "storage_key": "property/6767906449166922/019db17d-81af-7246-8eea-b20d09a18f73.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://elsik.aliefisd.net/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5303529202540355617&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "elsik-high-school",
      "poi_latitude": "29.7097439",
      "poi_longitude": "-95.6035149",
      "poi_miles_from_property": "3.8",
      "poi_walking_minutes": "1 hour 26 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-988-3150",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJb6dsNgfdQIYRISBU3bXrmUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "secondary_school"
    },
    {
      "id": "custom_12614195-8c5a-423e-ab34-699edeb45515",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Primrose School of The Westchase District",
      "poi_type": "Education",
      "poi_address": "3191 Briarpark Dr, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-9843-7317-aa64-b60aedd6f9eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Smiling young girl with a blue bow in her hair, in a classroom setting with a teacher and other children.",
        "public_id": "019db17d-9843-7317-aa64-b60aedd6f9eb",
        "storage_key": "property/6767906449166922/019db17d-9843-7317-aa64-b60aedd6f9eb.webp",
        "width": 1920,
        "height": 1080
      },
      "poi_business_url": "https://www.primroseschools.com/schools/westchase-district/?utm_source=gbp&utm_medium=maplistings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14246492622017909232&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "primrose-school-of-the-westchase-district",
      "poi_latitude": "29.7307759",
      "poi_longitude": "-95.5480447",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "50 mins",
      "poi_biking_minutes": "15 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-783-9800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJKY_tJSXDQIYR8NGZ_o61tcU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "preschool"
    },
    {
      "id": "custom_21f2d33b-8f97-41d4-99c1-250b5121a400",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Westchase Academy & Daycare",
      "poi_type": "Education",
      "poi_address": "10085 Westpark Dr, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-996c-7639-b936-6fac732b4355.webp",
      "poi_featured_image_media": {
        "alt_text": "Chalkboard art with fall leaves, a bus, butterflies, flowers, and pencils. Text reads 'Inspiring Curiosity, Creating Confidence'.",
        "public_id": "019db17d-996c-7639-b936-6fac732b4355",
        "storage_key": "property/6767906449166922/019db17d-996c-7639-b936-6fac732b4355.webp",
        "width": 3045,
        "height": 1350
      },
      "poi_business_url": "http://westchaseacademydaycare.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=98536654294868563&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-academy--daycare",
      "poi_latitude": "29.722525",
      "poi_longitude": "-95.544852",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 1 min",
      "poi_biking_minutes": "17 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-783-2520",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJsRJ7ISHDQIYRU-KZpJASXgE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "child_care_agency"
    },
    {
      "id": "custom_5db0cb7d-f7b1-416d-8046-167aca24f76c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Star Cinema Grill CityCenter",
      "poi_type": "Entertainment",
      "poi_address": "CityCenter, 822 Town and Country Blvd Suite 200, Houston, TX 77024, USA",
      "poi_short_description": "Theatre featuring seat-side service, reclining chairs, heated seats and an expanded menu.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-9b78-76a9-af94-05ba3302c908.webp",
      "poi_featured_image_media": {
        "alt_text": "Hallway with framed portraits of women",
        "public_id": "019db17d-9b78-76a9-af94-05ba3302c908",
        "storage_key": "property/6767906449166922/019db17d-9b78-76a9-af94-05ba3302c908.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.starcinemagrill.net/movie-theater/citycentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=5867569438081115187&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "star-cinema-grill-citycenter",
      "poi_latitude": "29.7816296",
      "poi_longitude": "-95.5610211",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 38 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-277-7910",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-85fe-773a-a3cc-4a79ec9265d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-85fe-773a-a3cc-4a79ec9265d9",
        "storage_key": "property/6767906449166922/019d08b1-85fe-773a-a3cc-4a79ec9265d9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJHdroU0PFQIYRM2TD81DLbVE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_28204dff-0d63-4bef-84df-e2aafc0e1732",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Cinemark Memorial City",
      "poi_type": "Entertainment",
      "poi_address": "310 Memorial City Mall, Houston, TX 77024, USA",
      "poi_short_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_long_description": "Chain of movie theaters, some with multiple screens, stadium seats & self-service ticketing kiosks.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-99d8-76ef-a557-b82d7045f292.webp",
      "poi_featured_image_media": {
        "alt_text": "Movie theater lobby with concession stand and artwork",
        "public_id": "019db17d-99d8-76ef-a557-b82d7045f292",
        "storage_key": "property/6767906449166922/019db17d-99d8-76ef-a557-b82d7045f292.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.cinemark.com/theatres/tx-houston/cinemark-memorial-city?utm_medium=organic&utm_source=gmb&utm_campaign=local_listing_theater&utm_content=GMB_listing&y_source=1_MTc0OTMxNTktNzE1LWxvY2F0aW9uLndlYnNpdGU%3D",
      "poi_directions_map_url": "https://maps.google.com/?cid=13006184974408473747&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cinemark-memorial-city",
      "poi_latitude": "29.7799092",
      "poi_longitude": "-95.5408135",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 4 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "14 mins",
      "poi_business_phone": "+1 713-467-9749",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-85fe-773a-a3cc-4a79ec9265d9.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-85fe-773a-a3cc-4a79ec9265d9",
        "storage_key": "property/6767906449166922/019d08b1-85fe-773a-a3cc-4a79ec9265d9.webp",
        "width": 172,
        "height": 192
      },
      "poi_google_place_id": "ChIJSwXHNpfEQIYRk9yjElNAf7Q",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "movie_theater"
    },
    {
      "id": "custom_6997ec29-f830-4163-b5eb-4387b3fe78f2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Dave & Buster's Houston - Katy Fwy",
      "poi_type": "Entertainment",
      "poi_address": "7620 Katy Fwy #100, Houston, TX 77024, USA",
      "poi_short_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_long_description": "Family-friendly chain offering a sports-bar-style setting for American food & arcade games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-aa1d-767a-b130-cc1a6d49cc35.webp",
      "poi_featured_image_media": {
        "alt_text": "People cheering while watching football on multiple screens in a bar.",
        "public_id": "019db17d-aa1d-767a-b130-cc1a6d49cc35",
        "storage_key": "property/6767906449166922/019db17d-aa1d-767a-b130-cc1a6d49cc35.webp",
        "width": 3072,
        "height": 2074
      },
      "poi_business_url": "https://www.daveandbusters.com/us/en/about/locations/houston-katy-fwy",
      "poi_directions_map_url": "https://maps.google.com/?cid=6837744502642803136&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "dave--busters-houston---katy-fwy",
      "poi_latitude": "29.7862052",
      "poi_longitude": "-95.4659137",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 35 mins",
      "poi_biking_minutes": "53 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "+1 713-263-0303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJz5s0I7vGQIYRwIHnsGWM5F4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_747d2f2a-2832-47b0-914b-13c880135b39",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Topgolf Houston - Katy",
      "poi_type": "Entertainment",
      "poi_address": "1030 Memorial Brook Blvd, Houston, TX 77084, USA",
      "poi_short_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_long_description": "Sprawling entertainment venue with a high-tech driving range & swanky lounge with drinks & games.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-3242-75ae-8dc7-1f63be13581d.webp",
      "poi_featured_image_media": {
        "alt_text": "Conference room with tables and chairs, screens on wall",
        "public_id": "019d08b1-3242-75ae-8dc7-1f63be13581d",
        "storage_key": "property/6767906449166922/019d08b1-3242-75ae-8dc7-1f63be13581d.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://topgolf.com/us/houston-west/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11763942538676567838&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "topgolf-houston---katy",
      "poi_latitude": "29.7867434",
      "poi_longitude": "-95.6500505",
      "poi_miles_from_property": "7.5",
      "poi_walking_minutes": "2 hours 47 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-406-3176",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7f3b-7281-8cb5-535b04dc88dd",
        "storage_key": "property/6767906449166922/019d08b1-7f3b-7281-8cb5-535b04dc88dd.webp",
        "width": 139,
        "height": 192
      },
      "poi_google_place_id": "ChIJhW-E02bZQIYRHn_sL2nrQaM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "restaurant"
    },
    {
      "id": "custom_48cd48db-cc7b-4499-aa8d-84ce1795b88f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Lucky Strike Houston",
      "poi_type": "Entertainment",
      "poi_address": "925 Bunker Hill Rd, Houston, TX 77024, USA",
      "poi_short_description": "Modern venue offers a chill spot to hang among a full bar, upscale American eats & multiple lanes.",
      "poi_long_description": "Modern venue offers a chill spot to hang among a full bar, upscale American eats & multiple lanes.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-a5ed-763f-a5e9-0ba06afe4ee7.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern bowling alley with glowing blue lanes and seating areas.",
        "public_id": "019db17d-a5ed-763f-a5e9-0ba06afe4ee7",
        "storage_key": "property/6767906449166922/019db17d-a5ed-763f-a5e9-0ba06afe4ee7.webp",
        "width": 540,
        "height": 360
      },
      "poi_business_url": "https://www.luckystrikeent.com/location/lucky-strike-houston?utm_source=gbp&utm_medium=organic&utm_campaign=yext_listings",
      "poi_directions_map_url": "https://maps.google.com/?cid=14690440181169725292&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "lucky-strike-houston",
      "poi_latitude": "29.7801822",
      "poi_longitude": "-95.5320034",
      "poi_miles_from_property": "6.1",
      "poi_walking_minutes": "2 hours 15 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-461-1207",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJm-BiSZDEQIYRbB-_8ILt3ss",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "bowling_alley"
    },
    {
      "id": "custom_08cfb1b4-dcd1-457f-afc5-093aed7a277d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "The Galleria",
      "poi_type": "Entertainment",
      "poi_address": "5085 Westheimer Rd, Houston, TX 77056, USA",
      "poi_short_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_long_description": "Bright center with a glass roof offers ice skating & cafes, plus electronics & department stores.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-a846-7789-8cd8-9f5bf4640e41.webp",
      "poi_featured_image_media": {
        "alt_text": "Gucci store entrance in a mall.",
        "public_id": "019db17d-a846-7789-8cd8-9f5bf4640e41",
        "storage_key": "property/6767906449166922/019db17d-a846-7789-8cd8-9f5bf4640e41.webp",
        "width": 3072,
        "height": 1493
      },
      "poi_business_url": "https://www.simon.com/mall/the-galleria",
      "poi_directions_map_url": "https://maps.google.com/?cid=9080376292649229487&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-galleria",
      "poi_latitude": "29.7391955",
      "poi_longitude": "-95.4634342",
      "poi_miles_from_property": "7.1",
      "poi_walking_minutes": "2 hours 42 mins",
      "poi_biking_minutes": "44 mins",
      "poi_driving_minutes": "18 mins",
      "poi_business_phone": "+1 713-622-0663",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fb7-71ba-9b79-7c90a71e8f16",
        "storage_key": "property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJ0b3z7m7BQIYRr1w81iD6A34",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_c58db054-54bb-4903-9752-0d3502decca3",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "CITYCENTRE",
      "poi_type": "Entertainment",
      "poi_address": "800 Town and Country Blvd, Houston, TX 77024, USA",
      "poi_short_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_long_description": "Contemporary shopping compound featuring brand-name stores, restaurants & live music in the plaza.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db178-f587-743c-ad92-9988db8faaba.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior dining area with a bar, tables, chairs, and large windows overlooking an outdoor seating area.",
        "public_id": "019db178-f587-743c-ad92-9988db8faaba",
        "storage_key": "property/6767906449166922/019db178-f587-743c-ad92-9988db8faaba.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "https://www.citycentrehouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16787131420789938490&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citycentre",
      "poi_latitude": "29.7810228",
      "poi_longitude": "-95.5592668",
      "poi_miles_from_property": "4.5",
      "poi_walking_minutes": "1 hour 39 mins",
      "poi_biking_minutes": "28 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-463-4692",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-7fb7-71ba-9b79-7c90a71e8f16",
        "storage_key": "property/6767906449166922/019d08b1-7fb7-71ba-9b79-7c90a71e8f16.webp",
        "width": 192,
        "height": 177
      },
      "poi_google_place_id": "ChIJTQ_xOrPEQIYROpn7zRXf9-g",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "shopping_mall"
    },
    {
      "id": "custom_a4130216-6666-4f41-adfd-806cf38f4bcb",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "The Escape Game Houston (CityCentre)",
      "poi_type": "Entertainment",
      "poi_address": "794 Sorella Ct #127, Houston, TX 77024, USA",
      "poi_short_description": "Intricate escape-room puzzle attraction with 4 unique themes like “Gold Rush” & “playground.\"",
      "poi_long_description": "Intricate escape-room puzzle attraction with 4 unique themes like “Gold Rush” & “playground.\"",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-b461-72de-8232-593c7edc2914.webp",
      "poi_featured_image_media": {
        "alt_text": "Man in an orange shirt standing in a control room with blue and yellow accents.",
        "public_id": "019db17d-b461-72de-8232-593c7edc2914",
        "storage_key": "property/6767906449166922/019db17d-b461-72de-8232-593c7edc2914.webp",
        "width": 2133,
        "height": 1196
      },
      "poi_business_url": "https://theescapegame.com/houston/?utm_source=google&utm_medium=organic&utm_campaign=gbp&utm_id=hou-citycentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=7114105542941690278&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "the-escape-game-houston-citycentre",
      "poi_latitude": "29.7790105",
      "poi_longitude": "-95.5613137",
      "poi_miles_from_property": "4.2",
      "poi_walking_minutes": "1 hour 33 mins",
      "poi_biking_minutes": "27 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-999-1496",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJOzcF1LLEQIYRpkmtlUxhumI",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "amusement_center"
    },
    {
      "id": "custom_1806870d-43b7-4bff-ad5e-e31083466e31",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Houston Museum of Natural Science at Sugar Land",
      "poi_type": "Entertainment",
      "poi_address": "13016 University Blvd, Sugar Land, TX 77479, USA",
      "poi_short_description": "Offering hands-on exhibits, this museum features dinosaur fossils, an aquarium & a dome theater.",
      "poi_long_description": "Offering hands-on exhibits, this museum features dinosaur fossils, an aquarium & a dome theater.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-b6a9-756f-8705-c23ff708c534.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a dinosaur museum exhibit with skeletons and informational displays.",
        "public_id": "019db17d-b6a9-756f-8705-c23ff708c534",
        "storage_key": "property/6767906449166922/019db17d-b6a9-756f-8705-c23ff708c534.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.hmns.org/hmns-at-sugar-land/",
      "poi_directions_map_url": "https://maps.google.com/?cid=17969858377103886965&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-museum-of-natural-science-at-sugar-land",
      "poi_latitude": "29.5925686",
      "poi_longitude": "-95.6497095",
      "poi_miles_from_property": "13.6",
      "poi_walking_minutes": "5 hours 5 mins",
      "poi_biking_minutes": "1 hour 16 mins",
      "poi_driving_minutes": "20 mins",
      "poi_business_phone": "+1 281-313-2277",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8acc-770d-b85d-ffff15e6c2b5.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8acc-770d-b85d-ffff15e6c2b5",
        "storage_key": "property/6767906449166922/019d08b1-8acc-770d-b85d-ffff15e6c2b5.webp",
        "width": 176,
        "height": 192
      },
      "poi_google_place_id": "ChIJuxT9FUzhQIYRdcpaT_zCYfk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "museum"
    },
    {
      "id": "custom_13ad45a0-0175-4465-a812-cdfe0fa8c7d2",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "iFLY Indoor Skydiving - Houston Memorial",
      "poi_type": "Entertainment",
      "poi_address": "9540 Katy Fwy, Houston, TX 77055, USA",
      "poi_short_description": "Chain with state-of-the-art wind tunnels at indoor skydiving facilities for kids and adults.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-31f2-71ba-84ec-3b42579c597c.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-31f2-71ba-84ec-3b42579c597c",
        "storage_key": "property/6767906449166922/019d08b1-31f2-71ba-84ec-3b42579c597c.webp",
        "width": 1080,
        "height": 608
      },
      "poi_business_url": "https://www.iflyworld.com/houston-memorial/?utm_source=G&utm_medium=local&utm_campaign=google-local",
      "poi_directions_map_url": "https://maps.google.com/?cid=7511237602402207819&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "ifly-indoor-skydiving---houston-memorial",
      "poi_latitude": "29.78545799999999",
      "poi_longitude": "-95.527056",
      "poi_miles_from_property": "6.7",
      "poi_walking_minutes": "2 hours 29 mins",
      "poi_biking_minutes": "39 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 281-942-4359",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ23szRIzEQIYRS4i9ms1GPWg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "sports_activity_location"
    },
    {
      "id": "custom_847e5b44-67fa-4091-a64d-7c32dc1ee9d8",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "HCA Houston ER 24/7 - Westchase",
      "poi_type": "Health and Wellness",
      "poi_address": "11103 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-3afa-7241-90ad-392d87d88141.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-3afa-7241-90ad-392d87d88141",
        "storage_key": "property/6767906449166922/019d08b1-3afa-7241-90ad-392d87d88141.webp",
        "width": 617,
        "height": 347
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/hca-houston-er-24-7-westchase?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=11259115014254944631&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-er-247---westchase",
      "poi_latitude": "29.7363082",
      "poi_longitude": "-95.5721252",
      "poi_miles_from_property": "0.5",
      "poi_walking_minutes": "12 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "2 mins",
      "poi_business_phone": "+1 832-708-3651",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJjaObMQfdQIYRd-HuvXNpQJw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "service"
    },
    {
      "id": "custom_c7296930-d2cd-423b-9510-594cff5b9d49",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Memorial Hermann-GoHealth Urgent Care",
      "poi_type": "Health and Wellness",
      "poi_address": "11700 Westheimer Rd ste j, Houston, TX 77077, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-bb77-705a-a0a0-0a8265e8a8a4.webp",
      "poi_featured_image_media": {
        "alt_text": "Urgent care building exterior with signage",
        "public_id": "019db17d-bb77-705a-a0a0-0a8265e8a8a4",
        "storage_key": "property/6767906449166922/019db17d-bb77-705a-a0a0-0a8265e8a8a4.webp",
        "width": 636,
        "height": 757
      },
      "poi_business_url": "https://www.gohealthuc.com/memorialhermann/locations/royal-oaks-centre?utm_source=gmb&utm_medium=organic&utm_content=memorialhermann-royaloakscentre",
      "poi_directions_map_url": "https://maps.google.com/?cid=4972540115267109553&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-gohealth-urgent-care",
      "poi_latitude": "29.7372554",
      "poi_longitude": "-95.5842518",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "4 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 346-575-0067",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGRGL3WPdQIYRsULgoeMCAkU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_580e88ab-cf38-435a-ac6a-2bd312222f37",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Kelsey-Seybold Clinic | Westchase",
      "poi_type": "Health and Wellness",
      "poi_address": "11284 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-c335-71ac-b6b4-f770de628d66.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior of a modern building with a curved entrance and the Kelsey-Seybold logo.",
        "public_id": "019db17d-c335-71ac-b6b4-f770de628d66",
        "storage_key": "property/6767906449166922/019db17d-c335-71ac-b6b4-f770de628d66.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.kelsey-seybold.com/find-a-location/westchase-clinic?utm_source=googlemybusiness&utm_medium=backlink&utm_campaign=location&eid=200000410&cid=googlemybusiness_backlink_location_200000410",
      "poi_directions_map_url": "https://maps.google.com/?cid=3410292602054552000&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "kelsey-seybold-clinic--westchase",
      "poi_latitude": "29.737185",
      "poi_longitude": "-95.5750728",
      "poi_miles_from_property": "0.4",
      "poi_walking_minutes": "10 mins",
      "poi_biking_minutes": "3 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-442-7700",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9aoBq3bdQIYRwKmalQ3LUy8",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "doctor"
    },
    {
      "id": "custom_1065a39e-7806-46e8-a824-b59edb96af79",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "CVS Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "10801 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-0fe0-7729-a553-9145fc134a08.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-0fe0-7729-a553-9145fc134a08",
        "storage_key": "property/6767906449166922/019d08b1-0fe0-7729-a553-9145fc134a08.webp",
        "width": 1280,
        "height": 1280
      },
      "poi_business_url": "https://www.cvs.com/store-locator/houston-tx-pharmacies/10801-westheimer-rd-houston-tx-77042/storeid=16017?WT.mc_id=LS_GOOGLE_RX_16017",
      "poi_directions_map_url": "https://maps.google.com/?cid=7861612795573398770&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "cvs-pharmacy",
      "poi_latitude": "29.7349897",
      "poi_longitude": "-95.5678231",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "6 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-580-0178",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ee-730e-9d75-2780a981fe47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ee-730e-9d75-2780a981fe47",
        "storage_key": "property/6767906449166922/019d08b1-84ee-730e-9d75-2780a981fe47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ7XTKs87cQIYR8mzRWS8PGm0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_9ba8d88b-a77f-44a9-9d95-611528b00732",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Westchase Health Clinic",
      "poi_type": "Health and Wellness",
      "poi_address": "13450 Richmond Ave # 100, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-4204-70c8-b015-75e93b482a68.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-4204-70c8-b015-75e93b482a68",
        "storage_key": "property/6767906449166922/019d08b1-4204-70c8-b015-75e93b482a68.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "https://www.westchasehealth.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15667913469852592681&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-health-clinic",
      "poi_latitude": "29.7300107",
      "poi_longitude": "-95.6269298",
      "poi_miles_from_property": "3.6",
      "poi_walking_minutes": "1 hour 22 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "12 mins",
      "poi_business_phone": "+1 281-556-0200",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJ4dyjAPDcQIYRKSof5kmcb9k",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_clinic"
    },
    {
      "id": "custom_79cf0ce8-c227-4a68-ad1a-3b4220d4dc82",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Walgreens Pharmacy",
      "poi_type": "Health and Wellness",
      "poi_address": "11038 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_long_description": "Department of the Walgreens chain providing prescription medications & other health-related items.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-c1a7-7150-9d45-6ba22b217556.webp",
      "poi_featured_image_media": {
        "alt_text": "A diverse group of pharmacists smiling in a pharmacy.",
        "public_id": "019db17d-c1a7-7150-9d45-6ba22b217556",
        "storage_key": "property/6767906449166922/019db17d-c1a7-7150-9d45-6ba22b217556.webp",
        "width": 1446,
        "height": 660
      },
      "poi_business_url": "https://www.walgreens.com/locator/walgreens-11038+westheimer+rd-houston-tx-77042/id=7251",
      "poi_directions_map_url": "https://maps.google.com/?cid=9070984065000508856&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "walgreens-pharmacy",
      "poi_latitude": "29.737402",
      "poi_longitude": "-95.5713306",
      "poi_miles_from_property": "0.6",
      "poi_walking_minutes": "14 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-789-4847",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ee-730e-9d75-2780a981fe47.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ee-730e-9d75-2780a981fe47",
        "storage_key": "property/6767906449166922/019d08b1-84ee-730e-9d75-2780a981fe47.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJrwlNkcjcQIYRuI2VbfKb4n0",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "pharmacy"
    },
    {
      "id": "custom_50ad9608-0107-442c-b66b-05c65fd4cd9a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Planet Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "10770 Westheimer Rd, Houston, TX 77042, USA",
      "poi_short_description": "Clean gym offering cardio- and strength-training machines plus massage beds, and run by helpful staff.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-4338-7699-b9f7-1421d8f35f1b.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-4338-7699-b9f7-1421d8f35f1b",
        "storage_key": "property/6767906449166922/019d08b1-4338-7699-b9f7-1421d8f35f1b.webp",
        "width": 1280,
        "height": 720
      },
      "poi_business_url": "https://www.planetfitness.com/gyms/houston-westchase-tx?utm_medium=organic&utm_source=extnet",
      "poi_directions_map_url": "https://maps.google.com/?cid=12212685552691916244&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "planet-fitness",
      "poi_latitude": "29.7377373",
      "poi_longitude": "-95.5660911",
      "poi_miles_from_property": "0.9",
      "poi_walking_minutes": "21 mins",
      "poi_biking_minutes": "7 mins",
      "poi_driving_minutes": "4 mins",
      "poi_business_phone": "+1 713-359-0012",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJtWMIfELdQIYR1C2_-c0sfKk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "fitness_center"
    },
    {
      "id": "custom_ef668444-a17a-42e1-8dc7-c3239cd47e59",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "24 Hour Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "12553 Westheimer Rd, Houston, TX 77077, USA",
      "poi_short_description": "Spacious fitness facility featuring cardio machines, free weights and spin classes, plus a pool and sauna.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db179-373d-7364-a541-39339449b573.webp",
      "poi_featured_image_media": {
        "alt_text": "Gym equipment with weight stacks and cables in a fitness center.",
        "public_id": "019db179-373d-7364-a541-39339449b573",
        "storage_key": "property/6767906449166922/019db179-373d-7364-a541-39339449b573.webp",
        "width": 1730,
        "height": 3072
      },
      "poi_business_url": "https://www.24hourfitness.com/gyms/houston-tx/dairy-ashford-sport?Adb_id=GGL_LOC_ACQ_CDP",
      "poi_directions_map_url": "https://maps.google.com/?cid=10653352508494424995&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "24-hour-fitness",
      "poi_latitude": "29.7341821",
      "poi_longitude": "-95.6045559",
      "poi_miles_from_property": "2.2",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-493-1874",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJi3YkbF_cQIYRo6vTn6lP2JM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_0af83b3f-05d8-4513-85fe-57933be9ff18",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "LA Fitness",
      "poi_type": "Health and Wellness",
      "poi_address": "9603 Westheimer Rd, Houston, TX 77063, USA",
      "poi_short_description": "Clean fitness center with a pool, basketball courts and a sauna, plus strength classes.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db179-3804-721a-98e8-a8f73e7e1086.webp",
      "poi_featured_image_media": {
        "alt_text": "LA Fitness building exterior at sunset",
        "public_id": "019db179-3804-721a-98e8-a8f73e7e1086",
        "storage_key": "property/6767906449166922/019db179-3804-721a-98e8-a8f73e7e1086.webp",
        "width": 3072,
        "height": 2119
      },
      "poi_business_url": "https://www.lafitness.com/Pages/clubhome.aspx?clubid=674&utm_source=google&utm_medium=googlemaps&utm_campaign=maps",
      "poi_directions_map_url": "https://maps.google.com/?cid=1923095509877188466&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "la-fitness",
      "poi_latitude": "29.7362567",
      "poi_longitude": "-95.5363836",
      "poi_miles_from_property": "2.7",
      "poi_walking_minutes": "1 hour 2 mins",
      "poi_biking_minutes": "21 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-470-4098",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJGVS8gxbDQIYRcudgXy01sBo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "gym"
    },
    {
      "id": "custom_6dbb4d02-5673-466e-9896-bfce0460f5cf",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Woodchase Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3951 Woodchase Dr, Houston, TX 77042, USA",
      "poi_short_description": "Opened in late October 2021, this family-friendly park in Westchase features a children's playground, a water misting feature, and a community garden. There's also a dog park, a fitness space, and a 2,700-square-foot multi-purpose pavilion.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-49c1-761c-82a5-668279597c7d.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-49c1-761c-82a5-668279597c7d",
        "storage_key": "property/6767906449166922/019d08b1-49c1-761c-82a5-668279597c7d.webp",
        "width": 1280,
        "height": 960
      },
      "poi_business_url": "http://woodchasepark.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11614271494229080655&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "woodchase-park",
      "poi_latitude": "29.7205792",
      "poi_longitude": "-95.5438708",
      "poi_miles_from_property": "2.8",
      "poi_walking_minutes": "1 hour 5 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 832-615-7303",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJCbjA84zDQIYRTzp4kmMuLqE",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_c7d8bceb-7e71-474f-9ef1-73d00daed59f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Camden Park Westchase",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "2951 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Popular park featuring a splash pad, dog parks and a playground for kids.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-4a64-7378-83c4-b386fce169c6.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-4a64-7378-83c4-b386fce169c6",
        "storage_key": "property/6767906449166922/019d08b1-4a64-7378-83c4-b386fce169c6.webp",
        "width": 1280,
        "height": 714
      },
      "poi_business_url": "https://camdenparkwestchase.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7949308463253431202&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "camden-park-westchase",
      "poi_latitude": "29.729676",
      "poi_longitude": "-95.5707528",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 713-780-9434",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJMVhvDqDdQIYRoiM6Gu6dUW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_784017b4-73aa-4c40-b3fd-a5d168eeb876",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Robinson-Westchase Neighborhood Library",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3223 Wilcrest Dr, Houston, TX 77042, USA",
      "poi_short_description": "Public library with adult and teen sections, study areas, and computer stations.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-c50f-758e-aa5e-641c3f4337eb.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of a library with bookshelves, computers, and seating areas.",
        "public_id": "019db17d-c50f-758e-aa5e-641c3f4337eb",
        "storage_key": "property/6767906449166922/019db17d-c50f-758e-aa5e-641c3f4337eb.webp",
        "width": 3072,
        "height": 1728
      },
      "poi_business_url": "https://houstonlibrary.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=7941327775849430878&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "robinson-westchase-neighborhood-library",
      "poi_latitude": "29.7289564",
      "poi_longitude": "-95.571072",
      "poi_miles_from_property": "0.7",
      "poi_walking_minutes": "16 mins",
      "poi_biking_minutes": "5 mins",
      "poi_driving_minutes": "3 mins",
      "poi_business_phone": "+1 832-393-2011",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJS0_8FtDcQIYRXr9yhIlDNW4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "library"
    },
    {
      "id": "custom_104c1f10-504f-4dba-8269-41c9a314ea26",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Arthur Storey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "7400 W Sam Houston Pkwy S, Houston, TX 77036, USA",
      "poi_short_description": "Green space centered around a pond, with a jogging trail along a narrow bayou & a tai chi court.",
      "poi_long_description": "Green space centered around a pond, with a jogging trail along a narrow bayou & a tai chi court.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db179-546a-779e-9ce0-4f082db106cd.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides and climbing structures.",
        "public_id": "019db179-546a-779e-9ce0-4f082db106cd",
        "storage_key": "property/6767906449166922/019db179-546a-779e-9ce0-4f082db106cd.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://hcp4.net/parks/arthur-storey-park",
      "poi_directions_map_url": "https://maps.google.com/?cid=15899668444003781872&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "arthur-storey-park",
      "poi_latitude": "29.7002473",
      "poi_longitude": "-95.5606594",
      "poi_miles_from_property": "3.4",
      "poi_walking_minutes": "1 hour 17 mins",
      "poi_biking_minutes": "19 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJkSi-DMrCQIYR8ExVszX4ptw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_bb05ef01-d833-42f7-a403-31726ff425ac",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Edith L Moore Nature Sanctuary",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "440 Wilchester Blvd, Houston, TX 77079, USA",
      "poi_short_description": "Privately-owned forest reserve & wildlife haven spanning 18 acres with an educational nature trail.",
      "poi_long_description": "Privately-owned forest reserve & wildlife haven spanning 18 acres with an educational nature trail.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-c840-724f-926b-c71c596b062f.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk through a sun-dappled forest with mist.",
        "public_id": "019db17d-c840-724f-926b-c71c596b062f",
        "storage_key": "property/6767906449166922/019db17d-c840-724f-926b-c71c596b062f.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://houstonaudubon.org/conservation/sanctuaries/edith-moore/",
      "poi_directions_map_url": "https://maps.google.com/?cid=3787825092045602411&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "edith-l-moore-nature-sanctuary",
      "poi_latitude": "29.7706834",
      "poi_longitude": "-95.5683116",
      "poi_miles_from_property": "3.5",
      "poi_walking_minutes": "1 hour 18 mins",
      "poi_biking_minutes": "18 mins",
      "poi_driving_minutes": "10 mins",
      "poi_business_phone": "+1 713-932-1639",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJI9XyNFHbQIYRa36wOtoOkTQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "nature_preserve"
    },
    {
      "id": "custom_06036b82-7d1b-4bfd-9d33-6eb26c9723b1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Vietnam Veterans Memorial City of Houston",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "9680 Club Creek Dr, Houston, TX 77036, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-ce8c-72a9-a2aa-21dcfea265fc.webp",
      "poi_featured_image_media": {
        "alt_text": "Memorial wall with US flag and engraved names of veterans, set against a cloudy sky.",
        "public_id": "019db17d-ce8c-72a9-a2aa-21dcfea265fc",
        "storage_key": "property/6767906449166922/019db17d-ce8c-72a9-a2aa-21dcfea265fc.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=17977365315809648213&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "vietnam-veterans-memorial-city-of-houston",
      "poi_latitude": "29.6796938",
      "poi_longitude": "-95.5469272",
      "poi_miles_from_property": "5.4",
      "poi_walking_minutes": "2 hours 1 min",
      "poi_biking_minutes": "33 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJqxXZ64fDQIYRVR5DroFufPk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_a179f815-84a6-498c-bb62-138ffd53f358",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Terry Hershey Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "15200 Memorial Dr, Houston, TX 77079, USA",
      "poi_short_description": "Extensive network of hiking & biking trails along a stretch of Buffalo Bayou encompassing 500 acres.",
      "poi_long_description": "Extensive network of hiking & biking trails along a stretch of Buffalo Bayou encompassing 500 acres.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-df54-754e-b029-4613ca73341c.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with slides, swings, and climbing structures surrounded by trees.",
        "public_id": "019db17d-df54-754e-b029-4613ca73341c",
        "storage_key": "property/6767906449166922/019db17d-df54-754e-b029-4613ca73341c.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=839903759849692222&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "terry-hershey-park",
      "poi_latitude": "29.7817875",
      "poi_longitude": "-95.623719",
      "poi_miles_from_property": "5.6",
      "poi_walking_minutes": "2 hours 3 mins",
      "poi_biking_minutes": "32 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJnSEHspTbQIYRPhxbAwXwpws",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_671064bf-fc4d-4850-8092-0976fe59b255",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "George Bush Park Bike Trail",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "16756 Westheimer Pkwy, Houston, TX 77082, USA",
      "poi_short_description": "Family-friendly park with scenic views and a long trail for walking, biking or running.",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-d0c9-7453-83e4-e2c7a33c1bf6.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk winding through a wooded area with a cyclist in the distance.",
        "public_id": "019db17d-d0c9-7453-83e4-e2c7a33c1bf6",
        "storage_key": "property/6767906449166922/019db17d-d0c9-7453-83e4-e2c7a33c1bf6.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=469630594180836084&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-park-bike-trail",
      "poi_latitude": "29.7236788",
      "poi_longitude": "-95.6875102",
      "poi_miles_from_property": "14.3",
      "poi_walking_minutes": "5 hours 14 mins",
      "poi_biking_minutes": "47 mins",
      "poi_driving_minutes": "17 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJ9-5hIuDeQIYR9OrNhYl2hAY",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_f70f091a-ffc9-4226-b67c-e758addac12f",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Bear Creek Pioneers Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "3535 War Memorial St, Houston, TX 77084, USA",
      "poi_short_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_long_description": "Wooded park known for abundant wildlife such as deer & ducks, with many trails, fields & activities.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-dd55-76db-bb04-80089000903e.webp",
      "poi_featured_image_media": {
        "alt_text": "Playground with swings and a slide.",
        "public_id": "019db17d-dd55-76db-bb04-80089000903e",
        "storage_key": "property/6767906449166922/019db17d-dd55-76db-bb04-80089000903e.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://cp4.harriscountytx.gov/Parks",
      "poi_directions_map_url": "https://maps.google.com/?cid=15025692315525117298&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bear-creek-pioneers-park",
      "poi_latitude": "29.8252332",
      "poi_longitude": "-95.6270195",
      "poi_miles_from_property": "9.6",
      "poi_walking_minutes": "3 hours 30 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "21 mins",
      "poi_business_phone": "+1 281-353-8100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJPwGbtFzaQIYRcvUwK437hdA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_d12fe63a-1bb5-4bba-8e5b-4b946c2198fc",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Memorial Park",
      "poi_type": "Nature & Outdoor Attractions",
      "poi_address": "6501 Memorial Dr, Houston, TX 77007, USA",
      "poi_short_description": "Expansive city park with lush natural features, popular running trail, golf course & lots of shade.",
      "poi_long_description": "Expansive city park with lush natural features, popular running trail, golf course & lots of shade.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-eaa4-76f9-b183-af69aebee6a0.webp",
      "poi_featured_image_media": {
        "alt_text": "Wooden boardwalk winding through a lush green landscape with a calm body of water reflecting the trees and sky.",
        "public_id": "019db17d-eaa4-76f9-b183-af69aebee6a0",
        "storage_key": "property/6767906449166922/019db17d-eaa4-76f9-b183-af69aebee6a0.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.memorialparkconservancy.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=822229581796948790&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-park",
      "poi_latitude": "29.7667498",
      "poi_longitude": "-95.4410469",
      "poi_miles_from_property": "10",
      "poi_walking_minutes": "3 hours 45 mins",
      "poi_biking_minutes": "58 mins",
      "poi_driving_minutes": "19 mins",
      "poi_business_phone": "+1 713-863-8403",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8b49-72a4-9a99-2282c6d0acd4",
        "storage_key": "property/6767906449166922/019d08b1-8b49-72a4-9a99-2282c6d0acd4.webp",
        "width": 162,
        "height": 192
      },
      "poi_google_place_id": "ChIJDyV1iizBQIYRNjvTwnIlaQs",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park"
    },
    {
      "id": "custom_ff61f44e-3911-4bef-bed4-a05741d94f15",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Westchase Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11050 Harwin Dr., Houston, TX 77072, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-f0e6-722c-a88c-97fe07a97042.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered bus stop with modern architecture and clear skies.",
        "public_id": "019db17d-f0e6-722c-a88c-97fe07a97042",
        "storage_key": "property/6767906449166922/019db17d-f0e6-722c-a88c-97fe07a97042.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5396743279492684688&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westchase-park-and-ride",
      "poi_latitude": "29.717204",
      "poi_longitude": "-95.5628297",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "47 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8bc8-777c-964e-1cf2c9ff4d5f",
        "storage_key": "property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJIX9fwSrdQIYRkFsjZmsV5Uo",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_c45593dd-991f-4070-a6b7-bbf5b4d428d4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Gessner Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9925 Westpark Dr, Houston, TX 77063, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-f095-7027-b9d4-5e213f562565.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered outdoor seating area with modern white roof and concrete pillars.",
        "public_id": "019db17d-f095-7027-b9d4-5e213f562565",
        "storage_key": "property/6767906449166922/019db17d-f095-7027-b9d4-5e213f562565.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=8759854959400057547&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "gessner-park-and-ride",
      "poi_latitude": "29.72044959999999",
      "poi_longitude": "-95.5374292",
      "poi_miles_from_property": "3.2",
      "poi_walking_minutes": "1 hour 13 mins",
      "poi_biking_minutes": "20 mins",
      "poi_driving_minutes": "9 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8bc8-777c-964e-1cf2c9ff4d5f",
        "storage_key": "property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJYdfhzB_DQIYRy_r7gqxBkXk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_c76e8e71-2676-4348-9055-6f70123fe981",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Westpark/Lower Uptown Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "5105 Westpark Dr, Houston, TX 77056, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17d-f0de-753a-a720-47f69be12ede.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior stairs with black railings leading down to building entrances.",
        "public_id": "019db17d-f0de-753a-a720-47f69be12ede",
        "storage_key": "property/6767906449166922/019db17d-f0de-753a-a720-47f69be12ede.webp",
        "width": 1728,
        "height": 3072
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=2350213791813892094&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westparklower-uptown-transit-center",
      "poi_latitude": "29.72532499999999",
      "poi_longitude": "-95.4650342",
      "poi_miles_from_property": "7.6",
      "poi_walking_minutes": "2 hours 52 mins",
      "poi_biking_minutes": "45 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8bc8-777c-964e-1cf2c9ff4d5f",
        "storage_key": "property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJFUi1hV3BQIYR_ndK3_2inSA",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_85dce9e5-1129-4fd7-b276-112765f54734",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Mission Bend Transit Center",
      "poi_type": "Transportation & Transit",
      "poi_address": "13855 Alief Clodine Rd, Houston, TX 77083, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-079a-72cf-9d5e-7cbc92b6369e.webp",
      "poi_featured_image_media": {
        "alt_text": "Bus station with Metro RideSt logo and seating areas.",
        "public_id": "019db17e-079a-72cf-9d5e-7cbc92b6369e",
        "storage_key": "property/6767906449166922/019db17e-079a-72cf-9d5e-7cbc92b6369e.webp",
        "width": 2304,
        "height": 3072
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5645848562512495656&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "mission-bend-transit-center",
      "poi_latitude": "29.7112995",
      "poi_longitude": "-95.6294303",
      "poi_miles_from_property": "5.1",
      "poi_walking_minutes": "1 hour 54 mins",
      "poi_biking_minutes": "29 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8bc8-777c-964e-1cf2c9ff4d5f",
        "storage_key": "property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJt1S35MvdQIYRKAQ1yFoVWk4",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_df1d2d17-0504-4dc4-96fa-4e05c4ba6b68",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Westwood Park and Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "9990 Southwest Fwy, Houston, TX 77036, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-604a-76c5-9030-680b86102a06.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-604a-76c5-9030-680b86102a06",
        "storage_key": "property/6767906449166922/019d08b1-604a-76c5-9030-680b86102a06.webp",
        "width": 960,
        "height": 1280
      },
      "poi_business_url": "http://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=13297390603034044934&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "westwood-park-and-ride",
      "poi_latitude": "29.6719084",
      "poi_longitude": "-95.548911",
      "poi_miles_from_property": "5.8",
      "poi_walking_minutes": "2 hours 12 mins",
      "poi_biking_minutes": "35 mins",
      "poi_driving_minutes": "13 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8bc8-777c-964e-1cf2c9ff4d5f",
        "storage_key": "property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJJXAMnR3oQIYRBip2BU3Sibg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_cf7cefe4-048b-401f-b5b7-3df7e7e981c1",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "West Bellfort Park & Ride",
      "poi_type": "Transportation & Transit",
      "poi_address": "11415 Roark Rd, Houston, TX 77031, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-08ae-74cb-bb60-134e172805e1.webp",
      "poi_featured_image_media": {
        "alt_text": "Buses at a transit station with a covered waiting area.",
        "public_id": "019db17e-08ae-74cb-bb60-134e172805e1",
        "storage_key": "property/6767906449166922/019db17e-08ae-74cb-bb60-134e172805e1.webp",
        "width": 1200,
        "height": 800
      },
      "poi_business_url": "https://www.ridemetro.org/",
      "poi_directions_map_url": "https://maps.google.com/?cid=16998197063884199308&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "west-bellfort-park--ride",
      "poi_latitude": "29.654882",
      "poi_longitude": "-95.561027",
      "poi_miles_from_property": "6.5",
      "poi_walking_minutes": "2 hours 27 mins",
      "poi_biking_minutes": "36 mins",
      "poi_driving_minutes": "15 mins",
      "poi_business_phone": "+1 713-635-4000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8bc8-777c-964e-1cf2c9ff4d5f",
        "storage_key": "property/6767906449166922/019d08b1-8bc8-777c-964e-1cf2c9ff4d5f.webp",
        "width": 138,
        "height": 192
      },
      "poi_google_place_id": "ChIJC8Ag8-HnQIYRjNXnViu65es",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "park_and_ride"
    },
    {
      "id": "custom_5ec00ad0-8ebf-4dab-baa0-4fbd8fe16b4d",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "George Bush Intercontinental Airport",
      "poi_type": "Transportation & Transit",
      "poi_address": "2800 N Terminal Rd, Houston, TX 77032, USA",
      "poi_short_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_long_description": "Houston airport with an interterminal train & an outdoor sculpture depicting large, abstract flags.",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-0b11-75ac-8475-af9f9b2ad3a7.webp",
      "poi_featured_image_media": {
        "alt_text": "Interior of an airport terminal with shops and restaurants visible.",
        "public_id": "019db17e-0b11-75ac-8475-af9f9b2ad3a7",
        "storage_key": "property/6767906449166922/019db17e-0b11-75ac-8475-af9f9b2ad3a7.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "https://www.fly2houston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=11296915713098302001&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "george-bush-intercontinental-airport",
      "poi_latitude": "29.9931058",
      "poi_longitude": "-95.3416255",
      "poi_miles_from_property": "34.7",
      "poi_walking_minutes": "",
      "poi_biking_minutes": "3 hours 2 mins",
      "poi_driving_minutes": "40 mins",
      "poi_business_phone": "+1 281-230-3100",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-9272-702c-9b9e-a23439985259.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-9272-702c-9b9e-a23439985259",
        "storage_key": "property/6767906449166922/019d08b1-9272-702c-9b9e-a23439985259.webp",
        "width": 182,
        "height": 192
      },
      "poi_google_place_id": "ChIJx1VD2SO0QIYRMcLAyPy0xpw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "international_airport"
    },
    {
      "id": "custom_f6fe8a92-b3ac-4326-a26a-df5b0932ad28",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Phillips 66",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2331 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-6bf5-739d-9343-7f77418f6fe4.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-6bf5-739d-9343-7f77418f6fe4",
        "storage_key": "property/6767906449166922/019d08b1-6bf5-739d-9343-7f77418f6fe4.webp",
        "width": 800,
        "height": 533
      },
      "poi_business_url": "http://www.phillips66.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15860930961646065326&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "phillips-66",
      "poi_latitude": "29.7405404",
      "poi_longitude": "-95.5609181",
      "poi_miles_from_property": "1.4",
      "poi_walking_minutes": "32 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "6 mins",
      "poi_business_phone": "",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJZb3nsDrDQIYRrpbov6xYHdw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_dc6f690a-838b-431f-8a3e-16f9e2c83288",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "BMC Software",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2103 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-0f14-7691-83c2-40c32ee301ca.webp",
      "poi_featured_image_media": {
        "alt_text": "BMC Software logo sign.",
        "public_id": "019db17e-0f14-7691-83c2-40c32ee301ca",
        "storage_key": "property/6767906449166922/019db17e-0f14-7691-83c2-40c32ee301ca.webp",
        "width": 2048,
        "height": 1536
      },
      "poi_business_url": "http://www.bmc.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=5294375881449965582&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "bmc-software",
      "poi_latitude": "29.7425039",
      "poi_longitude": "-95.5594056",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 800-793-4262",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJ7FQr0rDQIYRDog4OdBmeUk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_e08a7082-37c1-4e15-bfad-33d175270478",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "CityWest",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2103 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-293a-716b-b831-ef72852817fd.webp",
      "poi_featured_image_media": {
        "alt_text": "Covered outdoor patio with bocce ball court and giant Connect Four game.",
        "public_id": "019db17e-293a-716b-b831-ef72852817fd",
        "storage_key": "property/6767906449166922/019db17e-293a-716b-b831-ef72852817fd.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.citywesthouston.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=1782394134118006672&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "citywest",
      "poi_latitude": "29.7416791",
      "poi_longitude": "-95.5587417",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "37 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-822-3800",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJAQDAiErDQIYRkP_XfQVWvBg",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "business_center"
    },
    {
      "id": "custom_b5e1dd4b-694b-4a13-b75b-b00c7b39fe67",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "SLB",
      "poi_type": "Major Employers & Offices",
      "poi_address": "10001 Richmond Ave, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-0fde-751d-af14-39bb8c88ba28.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern office building exterior with palm trees and manicured landscaping.",
        "public_id": "019db17e-0fde-751d-af14-39bb8c88ba28",
        "storage_key": "property/6767906449166922/019db17e-0fde-751d-af14-39bb8c88ba28.webp",
        "width": 3072,
        "height": 2304
      },
      "poi_business_url": "http://www.slb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15504635089586775105&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "slb",
      "poi_latitude": "29.72738489999999",
      "poi_longitude": "-95.5498955",
      "poi_miles_from_property": "2.1",
      "poi_walking_minutes": "49 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 713-789-9600",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJJU9_piXDQIYRQWTghneHK9c",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_d3d79eb8-1ab1-40d7-8bd7-30cdb48f2f6c",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Petrochina International Inc",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2000 W Sam Houston Pkwy S Suite 1300, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": null,
      "poi_featured_image_media": null,
      "poi_business_url": "",
      "poi_directions_map_url": "https://maps.google.com/?cid=6686983324860496108&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "petrochina-international-inc",
      "poi_latitude": "29.7458454",
      "poi_longitude": "-95.5594309",
      "poi_miles_from_property": "2",
      "poi_walking_minutes": "44 mins",
      "poi_biking_minutes": "12 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 832-325-7818",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJeYXTp0Y6wokR7DhFoefvzFw",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "corporate_office"
    },
    {
      "id": "custom_1b7cb02c-3121-4372-97e1-dfa586cc061a",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "ABB Inc.",
      "poi_type": "Major Employers & Offices",
      "poi_address": "3700 W Sam Houston Pkwy S, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-1651-77ce-ba9b-9466ead13d5c.webp",
      "poi_featured_image_media": {
        "alt_text": "Modern office building with reflective glass exterior and a large circular water feature with a metal sculpture in front.",
        "public_id": "019db17e-1651-77ce-ba9b-9466ead13d5c",
        "storage_key": "property/6767906449166922/019db17e-1651-77ce-ba9b-9466ead13d5c.webp",
        "width": 3072,
        "height": 2048
      },
      "poi_business_url": "http://www.abb.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=4905928342324721908&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "abb-inc",
      "poi_latitude": "29.7241246",
      "poi_longitude": "-95.5587989",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "39 mins",
      "poi_biking_minutes": "10 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 713-587-8000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJo9SwhSvDQIYR9DjJqdVbFUQ",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "manufacturer"
    },
    {
      "id": "custom_92c65f8b-3e5d-42d6-a406-075668b5fc51",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "HCA Houston Healthcare West",
      "poi_type": "Major Employers & Offices",
      "poi_address": "12141 Richmond Ave, Houston, TX 77082, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-39c7-76dd-b76d-a82013b3fed9.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-39c7-76dd-b76d-a82013b3fed9",
        "storage_key": "property/6767906449166922/019d08b1-39c7-76dd-b76d-a82013b3fed9.webp",
        "width": 1080,
        "height": 607
      },
      "poi_business_url": "https://www.hcahoustonhealthcare.com/locations/west?utm_campaign=corp_listings_mgmt&utm_source=google&utm_medium=business_listing",
      "poi_directions_map_url": "https://maps.google.com/?cid=266204689841745394&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "hca-houston-healthcare-west",
      "poi_latitude": "29.7288209",
      "poi_longitude": "-95.5942013",
      "poi_miles_from_property": "1.7",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "11 mins",
      "poi_driving_minutes": "7 mins",
      "poi_business_phone": "+1 281-558-3444",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8ad3-711e-b630-ca94414ea634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8ad3-711e-b630-ca94414ea634",
        "storage_key": "property/6767906449166922/019d08b1-8ad3-711e-b630-ca94414ea634.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJ5byGn_rcQIYR8m2PR8G_sQM",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "general_hospital"
    },
    {
      "id": "custom_7baf338d-a8fd-466f-a91f-2a5853311f94",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Memorial Hermann Memorial City Medical Center",
      "poi_type": "Major Employers & Offices",
      "poi_address": "921 Gessner Rd, Houston, TX 77024, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-1556-7371-af68-2619c11afc21.webp",
      "poi_featured_image_media": {
        "alt_text": "Medical Plaza 4 building exterior with a distinctive crown-like structure on top, against a clear blue sky.",
        "public_id": "019db17e-1556-7371-af68-2619c11afc21",
        "storage_key": "property/6767906449166922/019db17e-1556-7371-af68-2619c11afc21.webp",
        "width": 2410,
        "height": 3072
      },
      "poi_business_url": "https://memorialhermann.org/locations/memorial-city?utm_campaign=reputation-management&utm_segment=gmb_location-listing&utm_source=yext&utm_medium=organic-search",
      "poi_directions_map_url": "https://maps.google.com/?cid=7341386861309126237&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "memorial-hermann-memorial-city-medical-center",
      "poi_latitude": "29.780343",
      "poi_longitude": "-95.5469103",
      "poi_miles_from_property": "5.2",
      "poi_walking_minutes": "1 hour 55 mins",
      "poi_biking_minutes": "30 mins",
      "poi_driving_minutes": "11 mins",
      "poi_business_phone": "+1 713-242-3000",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8ad3-711e-b630-ca94414ea634.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8ad3-711e-b630-ca94414ea634",
        "storage_key": "property/6767906449166922/019d08b1-8ad3-711e-b630-ca94414ea634.webp",
        "width": 134,
        "height": 192
      },
      "poi_google_place_id": "ChIJQQQlc7zEQIYRXeYMO3TY4WU",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "medical_center"
    },
    {
      "id": "custom_bb131d4f-5948-4366-8e97-b7971378ded0",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Empyrean Benefit Solutions",
      "poi_type": "Major Employers & Offices",
      "poi_address": "2103 CityWest Blvd, Houston, TX 77042, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-7861-700f-bee6-17e339356742.webp",
      "poi_featured_image_media": {
        "alt_text": null,
        "public_id": "019d08b1-7861-700f-bee6-17e339356742",
        "storage_key": "property/6767906449166922/019d08b1-7861-700f-bee6-17e339356742.webp",
        "width": 1280,
        "height": 854
      },
      "poi_business_url": "http://www.goempyrean.com/",
      "poi_directions_map_url": "https://maps.google.com/?cid=15662987545280193273&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "empyrean-benefit-solutions",
      "poi_latitude": "29.742868",
      "poi_longitude": "-95.559464",
      "poi_miles_from_property": "1.8",
      "poi_walking_minutes": "40 mins",
      "poi_biking_minutes": "14 mins",
      "poi_driving_minutes": "8 mins",
      "poi_business_phone": "+1 281-768-2900",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-84ce-7358-b18b-dd1960128ebe",
        "storage_key": "property/6767906449166922/019d08b1-84ce-7358-b18b-dd1960128ebe.webp",
        "width": 192,
        "height": 192
      },
      "poi_google_place_id": "ChIJT9MCXufBQIYR-SLLtS8cXtk",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "false"
    },
    {
      "id": "custom_a37b8603-acc4-4b4a-a689-04d19ed51226",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "poi_name": "Houston City College - West Loop Campus",
      "poi_type": "Major Employers & Offices",
      "poi_address": "5601 W Loop S, Houston, TX 77081, USA",
      "poi_short_description": "",
      "poi_long_description": "",
      "poi_featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019db17e-2863-75ff-98d5-e5b638661663.webp",
      "poi_featured_image_media": {
        "alt_text": "Exterior view of the West Loop Campus building at night, featuring prominent signage.",
        "public_id": "019db17e-2863-75ff-98d5-e5b638661663",
        "storage_key": "property/6767906449166922/019db17e-2863-75ff-98d5-e5b638661663.webp",
        "width": 1930,
        "height": 1446
      },
      "poi_business_url": "http://www.hccs.edu/",
      "poi_directions_map_url": "https://maps.google.com/?cid=6584179847211332118&g_mp=CiVnb29nbGUubWFwcy5wbGFjZXMudjEuUGxhY2VzLkdldFBsYWNlEAIYBCAA",
      "poi_item_slug": "houston-city-college---west-loop-campus",
      "poi_latitude": "29.7214212",
      "poi_longitude": "-95.4581271",
      "poi_miles_from_property": "8.7",
      "poi_walking_minutes": "3 hours 18 mins",
      "poi_biking_minutes": "56 mins",
      "poi_driving_minutes": "16 mins",
      "poi_business_phone": "+1 713-718-7868",
      "poi_map_icon": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
      "poi_map_icon_media": {
        "alt_text": null,
        "public_id": "019d08b1-8590-712e-ba0e-50e15c833fe3",
        "storage_key": "property/6767906449166922/019d08b1-8590-712e-ba0e-50e15c833fe3.webp",
        "width": 192,
        "height": 162
      },
      "poi_google_place_id": "ChIJ28ALNp7BQIYRFjJRwq-0X1s",
      "poi_day_night_filter": "Day",
      "poi_place_primary_type": "university"
    }
  ],
  "office_hours": [
    {
      "id": "custom_77df836a-c2f4-44e1-98cf-01c033569c55",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "day": "MON",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_09d348e4-396e-4ce2-b35c-47bc4d900194",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "day": "TUE",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_d3cb513a-17c1-4418-9033-d186ee53af71",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "day": "WED",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_c59e89b9-c98a-4641-aa91-1313b5bf7591",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "day": "THU",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_b4586d09-a265-4969-8ebd-d612664bb2f5",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "day": "FRI",
      "open_time": "10:00",
      "close_time": "18:00"
    },
    {
      "id": "custom_e9e24b71-f0cc-43da-b77b-d054550fe302",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "day": "SAT",
      "open_time": "10:00",
      "close_time": "17:00"
    }
  ],
  "reviews": [
    {
      "id": "custom_b08f3a23-6d48-4e5e-be90-c39bd5a427e0",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "rating": "4.0",
      "name": "Faye Garvey",
      "text": "We have been staying here for the past year and a half. Tabitha is amazing! She always goes out her way and she is really for the residences here!\n\nWe’ve had some issues with noise and some other things with pest but they have always tried to accommodate and make things better!",
      "date": "2026-02-13",
      "title": ""
    },
    {
      "id": "custom_cd7cf811-3e7d-4922-8031-892b93e5f764",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "rating": "5.0",
      "name": "Blaine Spears",
      "text": "I’ve been living on the property for a year now, and it’s truly been a wonderful place to call home. The atmosphere is welcoming, and the property is well cared for.\nI want to give all the kudos to Tabetha she genuinely cares about her residents and the property. She is always communicative, professional, and attentive. Anytime there’s a question or concern, she responds promptly and goes above and beyond to help. Her top tier customer service and dedication really make a difference in the overall living experience. It’s clear she takes pride in what she does, and that level of care does not go unnoticed. I’m very grateful for everything she does for the community!",
      "date": "2026-02-24",
      "title": "false"
    },
    {
      "id": "custom_4aff6d60-2393-4906-939f-8e7de1cc62d2",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "rating": "5.0",
      "name": "Sheridan",
      "text": "I want to sincerely thank the maintenance team for their outstanding service. Ronnie and Nelson truly went above and beyond, even after hours, to make sure everything was handled with care and professionalism! Their responsiveness, dedication, and positive attitude did not go unnoticed. It’s rare to find people that shows this level of commitment and reliability! I genuinely appreciate their hard work and willingness to step up when it mattered most!! Thank you for setting such a high standard and you both are true definition of CUSTOMER SERVICE! KEEP UP THE STELLAR WORK! 5 STARS!!!",
      "date": "2026-03-01",
      "title": ""
    },
    {
      "id": "custom_e00d78f9-bd78-4761-a234-5e4fe98ec234",
      "source": "custom",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "rating": "5.0",
      "name": "Jake Cummings",
      "text": "Great place to live - clean, quiet, and well maintained. The management team is responsive, and Tabetha in particular stands out as a genuinely professional and helpful manager. She’s easy to reach, follows through, and clearly cares about residents. Overall, a smooth, stress-free living experience.",
      "date": "2026-01-12",
      "title": ""
    }
  ],
  "virtual_tours": [
    {
      "id": "custom_7b991f0a-4376-4c8d-85f7-55e250e39961",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-9d7c-72ca-85e8-ae10494ffb94.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Living room with a sofa, coffee table, armchair, TV, and a balcony door.",
        "public_id": "019d08b1-9d7c-72ca-85e8-ae10494ffb94",
        "storage_key": "property/6767906449166922/019d08b1-9d7c-72ca-85e8-ae10494ffb94.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "1BR, 1BA - 770SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=zKZ287g6iaU&play=1&nt=1"
    },
    {
      "id": "custom_d56a1f89-5c20-4203-ba9f-c6abad72b9e4",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-9d30-75be-a516-27548eadd5ff.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Spacious living room with a sectional sofa, coffee table, and decorative mirror.",
        "public_id": "019d08b1-9d30-75be-a516-27548eadd5ff",
        "storage_key": "property/6767906449166922/019d08b1-9d30-75be-a516-27548eadd5ff.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "2BR, 1BA - 1,004 SF",
      "virtual_tour_type": "Apartment",
      "virtual_tour_url": "https://my.matterport.com/show/?m=Uv1WPvrFHAc&play=1"
    },
    {
      "id": "custom_a1b94c34-9b1d-4ad4-8c15-ffc06de707f6",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-9dbe-70bc-a41a-1598a16c61b7.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Business center with computers and seating.",
        "public_id": "019d08b1-9dbe-70bc-a41a-1598a16c61b7",
        "storage_key": "property/6767906449166922/019d08b1-9dbe-70bc-a41a-1598a16c61b7.webp",
        "width": 800,
        "height": 449
      },
      "virtual_tour_title": "Business Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=L9XJEdoaYyM&play=1"
    },
    {
      "id": "custom_5d8ef05e-9290-415b-a1e9-ae25006d114b",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "custom",
      "url_health_error": "",
      "virtual_tour_description": "Matterport 3D Showcase.",
      "virtual_tour_thumbnail": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b1-9d65-75ed-a7e2-2bb15bb63404.webp",
      "virtual_tour_thumbnail_media": {
        "alt_text": "Apartment gym with treadmills, ellipticals, and stationary bikes",
        "public_id": "019d08b1-9d65-75ed-a7e2-2bb15bb63404",
        "storage_key": "property/6767906449166922/019d08b1-9d65-75ed-a7e2-2bb15bb63404.webp",
        "width": 800,
        "height": 450
      },
      "virtual_tour_title": "Fitness Center",
      "virtual_tour_type": "Community",
      "virtual_tour_url": "https://my.matterport.com/show/?m=ETXie5ZwNDX&play=1"
    }
  ],
  "faqs": [],
  "fees": [],
  "pet_policies": [],
  "lead_collectors": [
    {
      "lead_collector_id": "019a930e-1783-711a-bb3f-5164f602c6f2",
      "lead_source": "PROPERTY_WEBSITE",
      "name": "rr-living-aura-at-westchase",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922"
    },
    {
      "lead_collector_id": "019af10e-56b9-75c2-a290-3feee21a66f1",
      "lead_source": "LANDING_PAGE",
      "name": "AURA at Westchase landing page",
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922"
    }
  ],
  "hyperlocal_queries": [
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "houston-apartments-in-unit-laundry",
      "search_query": "apartments with in-unit laundry in Houston TX",
      "category": "Amenity",
      "h1_title": "Apartments with In-Unit Laundry",
      "h2_subtitle": "Discover in-unit laundry convenience at AURA at Westchase in Houston, TX. Enjoy modern living with top amenities in our vibrant community.",
      "page_copy": "Experience the convenience of modern living at AURA at Westchase where apartments come with in-unit laundry in Houston, TX. Our thoughtfully designed one and two-bedroom homes are tailored for comfort, featuring complete laundry facilities, allowing you to manage chores at your own pace.\n\nSituated in Houston's dynamic Westside neighborhood, AURA at Westchase offers more than just in-unit laundry. Our amenity-rich community includes a state-of-the-art fitness center, serene walking trails, and even a dedicated pet washing station. With reserved parking and USB outlets, every detail is crafted to enhance your lifestyle. Make the smart choice and enjoy elevated living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments with In-Unit Laundry in Houston",
      "seo_description": "Find your ideal home at AURA at Westchase in Houston with in-unit laundry and premium amenities. Discover urban convenience and comfort today.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "luxury-apartments-private-garages-westside",
      "search_query": "luxury apartments with private garages Westside",
      "category": "Amenity",
      "h1_title": "Luxury Apartments with Private Garages",
      "h2_subtitle": "Explore luxury apartments with private garages at AURA at Westchase, nestled in Houston’s Westside. Embrace upscale living with unique amenities.",
      "page_copy": "Discover a new level of sophistication at AURA at Westchase, offering luxury apartments with private garages in Houston's desirable Westside. Each home is meticulously designed, providing not just a residence, but a retreat, where privacy and convenience are paramount. Enjoy the freedom of having attached garages that enhance your living experience.\n\nBeyond private garages, our community boasts a variety of upscale amenities. Residents have access to a state-of-the-art fitness center, serene walking trails, and a welcoming pet-friendly environment. With features like reserved parking and outlets equipped with USB ports, AURA at Westchase is the perfect place to elevate your lifestyle. Experience the best in luxury living today!",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Luxury Apartments with Private Garages Westside",
      "seo_description": "AURA at Westchase offers luxury living in Westside Houston with private garages. Discover premium amenities and elegant homes now.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "resort-style-pools-fitness-center-houston",
      "search_query": "resort style swimming pools and fitness center Houston",
      "category": "Amenity",
      "h1_title": "Resort Style Pools & Fitness Center",
      "h2_subtitle": "Enjoy resort-style swimming pools and a fitness center at AURA at Westchase, Houston. Transform your lifestyle with our exclusive amenities.",
      "page_copy": "At AURA at Westchase in Houston, resort-style amenities elevate everyday living. Dive into relaxation with our resort-style swimming pool, designed for leisure and fun. Whether you're taking a dip or lounging poolside, this is your personal oasis.\n\nOur community also features a state-of-the-art fitness center, ensuring you stay fit and active right at home. With advanced equipment and spacious workout areas, reaching your fitness goals has never been easier. Located in Houston's dynamic Westside, our pet-friendly environment and luxury amenities make AURA at Westchase the ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Resort Style Pool & Fitness Center in Houston",
      "seo_description": "Discover resort-style swimming pools and a modern fitness center at AURA at Westchase in Houston. Elevate your lifestyle with our exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "dog-park-pet-friendly-apartments-harris-county",
      "search_query": "dog park and pet-friendly apartments Harris County",
      "category": "Amenity",
      "h1_title": "Dog Park & Pet-Friendly Apartments",
      "h2_subtitle": "Find pet-friendly apartments with a dog park at AURA at Westchase in Harris County. Enjoy a vibrant community for you and your pet.",
      "page_copy": "Welcome to AURA at Westchase, where our pet-friendly apartments in Harris County are designed with both you and your furry friend in mind. We offer a unique lifestyle that includes a dedicated dog park, making it easy to enjoy outdoor fun and exercise with your pet.\n\nLocated in the vibrant Westside of Houston, our community provides more than just a dog park. Experience the convenience of a 24-hour pet washing station and an array of upscale amenities including a fitness center and serene walking trails. At AURA at Westchase, both you and your pet can enjoy a comfortable and welcoming home environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Dog Park & Pet-Friendly Apartments in Harris County",
      "seo_description": "AURA at Westchase offers pet-friendly living in Harris County with a dog park and luxury amenities. Make home a haven for you and your pet.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "modern-kitchens-stainless-steel-appliances-westchase",
      "search_query": "modern kitchens with stainless steel appliances Westchase",
      "category": "Amenity",
      "h1_title": "Modern Kitchens with Stainless Steel Appliances",
      "h2_subtitle": "Discover modern kitchens featuring stainless steel appliances at AURA at Westchase. Experience culinary excellence in the heart of Westchase.",
      "page_copy": "At AURA at Westchase, culinary enthusiasts will appreciate our modern kitchens outfitted with sleek stainless steel appliances. Located in the vibrant Westchase area, these kitchens are designed to inspire creativity and offer the ultimate cooking experience, complete with high-end finishes and details.\n\nEmbrace a lifestyle of convenience and luxury with additional features like gooseneck faucets and USB port outlets, turning meal preparations into a pleasure rather than a chore. Alongside these stunning kitchens, residents enjoy a wealth of community amenities, making AURA at Westchase the ideal choice for those seeking truly modern living spaces in Houston.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Modern Kitchens & Stainless Steel in Westchase",
      "seo_description": "Explore AURA at Westchase's modern kitchens with stainless steel appliances. Perfectly designed spaces for cooking in Houston's Westchase area.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "1-bedroom-apartment-houston-westside",
      "search_query": "1 bedroom apartment houston westside",
      "category": "Floorplan",
      "h1_title": "1 Bedroom Apartments in Houston Westside",
      "h2_subtitle": "Explore spacious 1-bedroom apartments in Houston Westside at AURA at Westchase. Discover comfort and convenience in every corner.",
      "page_copy": "At AURA at Westchase, our 1-bedroom apartments offer the perfect blend of style and functionality in Houston's desirable Westside. These thoughtfully designed spaces provide a cozy retreat with ample living areas, modern finishes, and natural light.\n\nResidents enjoy a host of community amenities, including a state-of-the-art fitness center and serene walking trails. Our pet-friendly environment also features a 24-hour pet washing station, ensuring convenience for you and your furry companions. Discover the charm of Houston Westside living at AURA at Westchase, where every detail is crafted for your comfort.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "1 Bedroom Apartment in Houston Westside",
      "seo_description": "Find your ideal 1-bedroom apartment at AURA at Westchase in Houston Westside. Enjoy modern living with exceptional amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "2-bedroom-apartments-near-westchase-houston",
      "search_query": "2 bedroom apartments near westchase houston",
      "category": "Floorplan",
      "h1_title": "2 Bedroom Apartments Near Westchase",
      "h2_subtitle": "Explore spacious 2-bedroom apartments near Westchase, Houston at AURA at Westchase. Enjoy modern living with top-tier amenities.",
      "page_copy": "Discover the perfect living space at AURA at Westchase, offering spacious 2-bedroom apartments near the vibrant Westchase area of Houston. Each apartment is designed to provide ample living room, stylish interiors, and convenience at your fingertips.\n\nSituated in a gated community, our residents enjoy an array of amenities such as reserved parking and serene walking trails. The attached garages* and modern kitchen features, like stainless steel appliances, add a touch of luxury to everyday living. Experience comfortable living with everything you need right outside your door in Houston's Westside.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "2 Bedroom Apartments Near Westchase, Houston",
      "seo_description": "Experience modern 2-bedroom apartment living near Westchase, Houston at AURA at Westchase. Enjoy luxury and comfort in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-near-alief-early-college-high-school",
      "search_query": "apartments near Alief Early College High School Houston",
      "category": "School",
      "h1_title": "Apartments Near Alief Early College High School",
      "h2_subtitle": "Find convenient apartments close to Alief Early College High School in Houston. Discover AURA at Westchase, where education meets lifestyle.",
      "page_copy": "AURA at Westchase offers an ideal location for families and students looking for apartments near Alief Early College High School in Houston. Our well-appointed residences provide the perfect blend of comfort and convenience, just minutes away from this prestigious institution.\n\nEnjoy living in a community that values education and convenience. Our outstanding amenities, such as a state-of-the-art fitness center, serene walking trails, and a pet-friendly setting, cater to diverse lifestyles. With modern living spaces and a prime location, AURA at Westchase ensures you stay connected to educational opportunities and vibrant community life.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Alief Early College High School",
      "seo_description": "Discover AURA at Westchase, offering apartments near Alief Early College High School in Houston. Enjoy comfort and convenience close to education.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "rentals-by-houston-city-college-alief-hayes-campus",
      "search_query": "rentals by Houston City College - Alief Hayes Campus",
      "category": "School",
      "h1_title": "Rentals by Houston City College, Alief",
      "h2_subtitle": "Discover convenient rentals near Houston City College, Alief Hayes Campus at AURA at Westchase. Perfect for students and professionals alike.",
      "page_copy": "AURA at Westchase offers ideal rentals for those seeking proximity to Houston City College's Alief Hayes Campus. Our apartments provide a balance of modern convenience and comfort, making them perfect for students and professionals.\n\nLocated in Houston's Westside, our community features state-of-the-art amenities like a pet-friendly environment, a comprehensive fitness center, and serene walking trails. Whether you're focusing on education or your career, AURA at Westchase ensures you have a welcoming home close to Houston City College's Alief Hayes Campus.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Houston City College, Alief",
      "seo_description": "Find rentals at AURA at Westchase near Houston City College, Alief Hayes Campus. Ideal for students and professionals in a prime Houston location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-close-to-holmquist-elementary-77082",
      "search_query": "apartments close to Holmquist Elementary School 77082",
      "category": "School",
      "h1_title": "Apartments Near Holmquist Elementary 77082",
      "h2_subtitle": "Discover family-friendly living with apartments close to Holmquist Elementary School in Houston's 77082 area. Welcome to AURA at Westchase.",
      "page_copy": "For families seeking a supportive neighborhood with access to quality education, AURA at Westchase offers apartments conveniently located near Holmquist Elementary School in the 77082 ZIP code area. Our community is tailored to provide a nurturing environment ideal for family living.\n\nResidents enjoy a range of amenities, including reserved parking, modern apartment features, and a welcoming pet-friendly setting. With spacious layouts and top-tier facilities, AURA at Westchase ensures a comfortable home life, complemented by the excellent educational opportunities at Holmquist Elementary School.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Holmquist Elementary, Houston 77082",
      "seo_description": "Explore family-friendly apartments close to Holmquist Elementary School, Houston 77082 at AURA at Westchase. Experience quality living and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "housing-near-rees-elementary-westside",
      "search_query": "housing near Rees Elementary School Westside",
      "category": "School",
      "h1_title": "Housing Near Rees Elementary, Westside",
      "h2_subtitle": "Explore convenient housing options near Rees Elementary School in Houston's Westside. AURA at Westchase offers the perfect family-friendly setting.",
      "page_copy": "Nestled in Houston's desirable Westside, AURA at Westchase provides exceptional housing opportunities near Rees Elementary School. Ideal for families seeking proximity to renowned educational institutions, our community blends comfort with convenience.\n\nExperience a vibrant lifestyle enhanced by our top-notch amenities such as a pet washing station, attached garages, and a modern fitness center. At AURA at Westchase, families benefit from spacious residences and a friendly community atmosphere, all while staying close to Rees Elementary School’s enriching learning environment.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Rees Elementary, Westside Houston",
      "seo_description": "Find family-friendly housing near Rees Elementary School, Westside Houston at AURA at Westchase. Enjoy comfort and convenience in a prime location.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-near-sneed-elementary-harris-county",
      "search_query": "apartments near Sneed Elementary School Harris County",
      "category": "School",
      "h1_title": "Apartments Near Sneed Elementary, Harris County",
      "h2_subtitle": "Discover exceptional living in Harris County with apartments near Sneed Elementary School. Enjoy the perfect community for families at AURA at Westchase.",
      "page_copy": "AURA at Westchase offers the ideal apartment community for families seeking proximity to schools like Sneed Elementary in Harris County. Our location provides a family-friendly setting with modern comforts.\n\nEnjoy spacious living areas complemented by community features such as a pet-friendly atmosphere, USB port outlets, and a fitness center. Families benefit from being close to Sneed Elementary School, ensuring easy access to quality education, all within a thriving and supportive environment at AURA at Westchase.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Sneed Elementary, Harris County",
      "seo_description": "Explore family-friendly apartments near Sneed Elementary School, Harris County at AURA at Westchase. Enjoy convenient access to education and amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "rentals-by-budewig-intermediate-houston",
      "search_query": "rentals by Budewig Intermediate School Houston",
      "category": "School",
      "h1_title": "Rentals by Budewig Intermediate, Houston",
      "h2_subtitle": "Located near Budewig Intermediate School, AURA at Westchase offers prime rental options in Houston. Discover the ideal community for families today.",
      "page_copy": "AURA at Westchase presents an excellent choice for families and individuals seeking rentals by Budewig Intermediate School in Houston. Our community prioritizes comfort and convenience in a vibrant setting.\n\nWith a host of features like a serene environment and modern amenities such as a pet washing station, attached garages, and a state-of-the-art fitness center, residents here enjoy a balanced lifestyle. Proximity to Budewig Intermediate School ensures that educational needs are met, making AURA at Westchase a preferred choice for family-friendly rentals.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rentals by Budewig Intermediate, Houston",
      "seo_description": "Discover family-friendly rentals near Budewig Intermediate School in Houston at AURA at Westchase. Ideal location with top amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-close-to-odonnell-middle-westside",
      "search_query": "apartments close to O'Donnell Middle School Westside",
      "category": "School",
      "h1_title": "Apartments Close to O'Donnell Middle, Westside",
      "h2_subtitle": "Seek apartments close to O'Donnell Middle School in Houston's Westside? Discover comfortable living at AURA at Westchase.",
      "page_copy": "AURA at Westchase is the perfect choice for those looking for apartments close to O'Donnell Middle School in Houston's Westside. Our community offers spacious living with modern amenities designed for convenience and comfort.\n\nLocated in a thriving neighborhood, residents can enjoy easy access to O'Donnell Middle School, along with amenities such as a fitness center, pet washing station, and garage options. AURA at Westchase provides a supportive environment for families and individuals, making it an ideal place to call home.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Close to O'Donnell Middle, Westside",
      "seo_description": "Find apartments near O'Donnell Middle School in Westside Houston at AURA at Westchase. Enjoy top amenities and convenient access to schools.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "housing-near-elsik-high-school-harris-county",
      "search_query": "housing near Elsik High School Harris County",
      "category": "School",
      "h1_title": "Housing Near Elsik High School, Harris County",
      "h2_subtitle": "Looking for housing near Elsik High School in Harris County? AURA at Westchase offers a perfect blend of comfort and convenience.",
      "page_copy": "AURA at Westchase provides an exceptional housing option for those desiring proximity to Elsik High School in Harris County. Our community is designed to offer both convenience and a high standard of living.\n\nExperience spacious and contemporary living spaces amidst a host of amenities including a pet-friendly environment, fitness center, and reserved parking. With close access to Elsik High School, our community is an ideal choice for families wanting quality education and a supportive community backdrop.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Housing Near Elsik High School, Harris County",
      "seo_description": "Discover excellent housing near Elsik High School in Harris County at AURA at Westchase. Enjoy modern amenities and a family-friendly community.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-near-woodchase-park-houston",
      "search_query": "apartments near Woodchase Park Houston",
      "category": "Park",
      "h1_title": "Apartments Near Woodchase Park, Houston",
      "h2_subtitle": "Explore apartments near Woodchase Park in Houston. AURA at Westchase offers serene living with a touch of luxury in a prime location.",
      "page_copy": "Nestled in an inviting setting, AURA at Westchase is the prime choice for those seeking apartments near Woodchase Park in Houston. Our community seamlessly combines urban accessibility with a touch of peaceful living.\n\nResidents can enjoy a wide range of amenities including a state-of-the-art fitness center, lush walking trails, and a community supportive of pets. The close proximity to Woodchase Park offers additional recreational opportunities, making AURA at Westchase a preferred home for nature lovers and those valuing convenience.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Woodchase Park, Houston",
      "seo_description": "Find serene living near Woodchase Park in Houston at AURA at Westchase. Enjoy top amenities and easy access to nature and city conveniences.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "rental-units-by-camden-park-westchase",
      "search_query": "rental units by Camden Park Westchase",
      "category": "Park",
      "h1_title": "Rental Units by Camden Park, Westchase",
      "h2_subtitle": "Searching for rental units by Camden Park in Westchase? AURA at Westchase offers perfect solutions with modern amenities.",
      "page_copy": "Discover exceptional rental units by Camden Park in the heart of Westchase at AURA at Westchase. Our community is designed to offer a harmonious blend of modern living and convenience.\n\nWith a variety of one and two-bedroom units, residents can enjoy amenities such as USB outlets, a pet washing station, and a state-of-the-art fitness center. Being located near Camden Park, our community provides ample recreational opportunities, making it an ideal choice for active lifestyles.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Rental Units by Camden Park, Westchase",
      "seo_description": "Explore top rental units by Camden Park in Westchase at AURA at Westchase. Enjoy modern amenities and a prime location near recreational areas.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "flats-close-to-arthur-storey-park-77082",
      "search_query": "flats close to Arthur Storey Park 77082",
      "category": "Park",
      "h1_title": "Flats Close to Arthur Storey Park, 77082",
      "h2_subtitle": "Looking for flats close to Arthur Storey Park in 77082? AURA at Westchase offers stylish and modern living options.",
      "page_copy": "Experience premium living with flats close to Arthur Storey Park in the 77082 area at AURA at Westchase. Our community combines the serenity of nature with innovative living spaces.\n\nOur residents benefit from a range of features such as a fully equipped fitness center, tranquil walking paths, and a pet-friendly environment. The strategic location near Arthur Storey Park makes it possible to enjoy leisure activities just a stone's throw away, ensuring a balanced lifestyle.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Flats Close to Arthur Storey Park, 77082",
      "seo_description": "Discover flats near Arthur Storey Park in 77082 at AURA at Westchase. Enjoy modern living with easy access to park amenities and nature.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "homes-near-vietnam-veterans-memorial-houston",
      "search_query": "homes near Vietnam Veterans Memorial Houston",
      "category": "Park",
      "h1_title": "Homes Near Vietnam Veterans Memorial, Houston",
      "h2_subtitle": "Find homes near Vietnam Veterans Memorial in Houston. AURA at Westchase offers comfort and convenience in a vibrant community.",
      "page_copy": "Located conveniently near the Vietnam Veterans Memorial in Houston, AURA at Westchase provides an ideal home setting for those seeking a vibrant community. Our homes embody a perfect mix of style and accessibility, catering to a variety of lifestyles.\n\nResidents appreciate the numerous amenities, including reserved parking, a 24-hour pet washing station, and stylish interiors featuring gooseneck faucets. The nearby Vietnam Veterans Memorial offers a place of reflection and history, enhancing the community's cultural richness and appeal.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Homes Near Vietnam Veterans Memorial, Houston",
      "seo_description": "Discover homes near Vietnam Veterans Memorial Houston at AURA at Westchase. Enjoy modern living with a touch of culture and convenience.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-close-to-terry-hershey-park-tx",
      "search_query": "apartments close to Terry Hershey Park TX",
      "category": "Park",
      "h1_title": "Apartments Near Terry Hershey Park, TX",
      "h2_subtitle": "Seeking apartments close to Terry Hershey Park in TX? AURA at Westchase offers serene living with modern conveniences.",
      "page_copy": "AURA at Westchase presents ideal apartments close to Terry Hershey Park, TX. Experience a balance of outdoor experiences and lavish living in our welcoming community.\n\nOur apartments offer features such as attached garages and USB-enabled outlets, enhancing daily convenience. The proximity to Terry Hershey Park means residents can easily indulge in regular strolls or bike rides amidst picturesque trails, making it perfect for those who appreciate an active lifestyle intertwined with nature.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near Terry Hershey Park, TX",
      "seo_description": "Explore apartments near Terry Hershey Park TX at AURA at Westchase. Offering modern amenities and access to serene park trails.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "residences-near-george-bush-park-bike-trail",
      "search_query": "residences near George Bush Park Bike Trail",
      "category": "Park",
      "h1_title": "Residences Near George Bush Park Bike Trail",
      "h2_subtitle": "Looking for residences near George Bush Park Bike Trail? Discover AURA at Westchase, where comfort meets convenience.",
      "page_copy": "Nestled in Houston, AURA at Westchase offers residences near the scenic George Bush Park Bike Trail, promoting an active and enriching lifestyle. Our community stands out with its combination of modern amenities and convenient location.\n\nEnjoy features such as a state-of-the-art fitness center and pet-friendly amenities, perfect for an energetic lifestyle. Living close to the George Bush Park Bike Trail allows residents to effortlessly partake in biking or walking adventures, making our residences an excellent choice for outdoor enthusiasts.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Residences Near George Bush Park Bike Trail",
      "seo_description": "Find residences near George Bush Park Bike Trail at AURA at Westchase. Ideal for an active lifestyle with modern amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "living-spaces-by-bear-creek-pioneers-park-harris-county",
      "search_query": "living spaces by Bear Creek Pioneers Park Harris County",
      "category": "Park",
      "h1_title": "Living Spaces by Bear Creek Pioneers Park",
      "h2_subtitle": "Explore living spaces by Bear Creek Pioneers Park in Harris County. AURA at Westchase offers the perfect blend of nature and modern living.",
      "page_copy": "Discover exceptional living spaces located by Bear Creek Pioneers Park in Harris County at AURA at Westchase. Our community offers a harmonious blend of natural beauty and contemporary comforts. \n\nRelish in our array of amenities, including a 24-hour pet washing station and reserved parking, designed to add convenience to your daily routine. Being close to Bear Creek Pioneers Park provides residents with easy access to outdoor recreation, making our living spaces ideal for those who value nature and accessibility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Living Spaces by Bear Creek Pioneers Park",
      "seo_description": "Discover living spaces by Bear Creek Pioneers Park, Harris County at AURA at Westchase. Perfect for nature and modern living enthusiasts.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "properties-near-memorial-park-westside",
      "search_query": "properties near Memorial Park Westside",
      "category": "Park",
      "h1_title": "Properties Near Memorial Park Westside",
      "h2_subtitle": "Searching for properties near Memorial Park in Westside? AURA at Westchase offers unmatched community amenities and park accessibility.",
      "page_copy": "Experience the best of Houston living with properties near Memorial Park in Westside. AURA at Westchase provides an ideal home surrounded by modern comforts and natural beauty.\n\nEnjoy amenities like a state-of-the-art fitness center and serene walking trails. Situated conveniently near Memorial Park, our properties are perfect for those who relish outdoor activities and city accessibility. Come discover a community that balances convenience and tranquility.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Properties Near Memorial Park Westside",
      "seo_description": "Explore properties near Memorial Park Westside at AURA at Westchase. Enjoy park access and unrivaled amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    },
    {
      "agency_id": "5680529164730368",
      "company_id": "5734677587427328",
      "property_id": "6767906449166922",
      "source": "generator",
      "page_item_url": "apartments-convenient-to-george-bush-airport-houston",
      "search_query": "apartments convenient to George Bush Intercontinental Airport Houston",
      "category": "Transit",
      "h1_title": "Apartments Near George Bush Airport Houston",
      "h2_subtitle": "Find apartments convenient to George Bush Intercontinental Airport in Houston. AURA at Westchase combines location with lifestyle.",
      "page_copy": "AURA at Westchase offers ideal apartments for those needing convenient access to George Bush Intercontinental Airport in Houston. Our community features expedient connectivity, perfect for frequent flyers and airport staff.\n\nExperience relaxed living with our courtesy amenities such as an attached garage and outlets with USB ports. Our proximity to the airport not only reduces commute times but also enhances your overall living experience with the added convenience of city attractions and recreational activities nearby.",
      "featured_image": "https://media.multihub.io/cdn-cgi/image/format=auto,w=1280/property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
      "featured_image_media": {
        "alt_text": "Aerial view of a swimming pool and lounge area with palm trees.",
        "public_id": "019d08b0-cea3-743d-94d7-62bbc297754c",
        "storage_key": "property/6767906449166922/019d08b0-cea3-743d-94d7-62bbc297754c.webp",
        "width": 1240,
        "height": 827
      },
      "blank_image": null,
      "blank_image_media": null,
      "seo_title": "Apartments Near George Bush Airport Houston",
      "seo_description": "Discover apartments near George Bush Airport Houston at AURA at Westchase. Offering convenience with top-notch amenities.",
      "include_apartmentsync": "false",
      "status": [
        "Draft"
      ]
    }
  ],
  "custom_fields": [
    {
      "ID": "custom_csm",
      "type": "STRING",
      "value": "cameron@repli360.com"
    },
    {
      "ID": "custom_qb_id",
      "type": "STRING",
      "value": "5640"
    },
    {
      "ID": "custom_repli_id",
      "type": "STRING",
      "value": "18004664758"
    },
    {
      "ID": "custom_realpage_id",
      "type": "STRING",
      "value": "5587917"
    },
    {
      "ID": "custom_knock_a_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=a"
    },
    {
      "ID": "custom_knock_g_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=g"
    },
    {
      "ID": "custom_knock_r_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=r"
    },
    {
      "ID": "custom_knock_w_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=w"
    },
    {
      "ID": "custom_knock_z_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=z"
    },
    {
      "ID": "custom_google_gtm_id",
      "type": "STRING",
      "value": "GTM-NPRMPS3R"
    },
    {
      "ID": "custom_knock_a_title",
      "type": "STRING",
      "value": "Apartments.com"
    },
    {
      "ID": "custom_knock_al_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=al"
    },
    {
      "ID": "custom_knock_ar_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=ar"
    },
    {
      "ID": "custom_knock_cl_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=cl"
    },
    {
      "ID": "custom_knock_fb_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=fb"
    },
    {
      "ID": "custom_knock_fl_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=fl"
    },
    {
      "ID": "custom_knock_g_title",
      "type": "STRING",
      "value": "Google"
    },
    {
      "ID": "custom_knock_gp_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=gp"
    },
    {
      "ID": "custom_knock_r_title",
      "type": "STRING",
      "value": "Rent.com"
    },
    {
      "ID": "custom_knock_w_title",
      "type": "STRING",
      "value": "Property Website"
    },
    {
      "ID": "custom_knock_z_title",
      "type": "STRING",
      "value": "Zillow"
    },
    {
      "ID": "custom_knock_a_number",
      "type": "STRING",
      "value": "832-307-0771"
    },
    {
      "ID": "custom_knock_ads_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=ads"
    },
    {
      "ID": "custom_knock_al_title",
      "type": "STRING",
      "value": "Apartment List"
    },
    {
      "ID": "custom_knock_ar_title",
      "type": "STRING",
      "value": "Apartment Ratings"
    },
    {
      "ID": "custom_knock_bnr_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=bnr"
    },
    {
      "ID": "custom_knock_cl_title",
      "type": "STRING",
      "value": "Craigslist"
    },
    {
      "ID": "custom_knock_fb_title",
      "type": "STRING",
      "value": "Facebook"
    },
    {
      "ID": "custom_knock_fl_title",
      "type": "STRING",
      "value": "Flag"
    },
    {
      "ID": "custom_knock_g_number",
      "type": "STRING",
      "value": "832-263-7859"
    },
    {
      "ID": "custom_knock_gp_title",
      "type": "STRING",
      "value": "Google (paid)"
    },
    {
      "ID": "custom_knock_lcs_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=lcs"
    },
    {
      "ID": "custom_knock_lgp_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=lgp"
    },
    {
      "ID": "custom_knock_ppn_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=ppn"
    },
    {
      "ID": "custom_knock_r_number",
      "type": "STRING",
      "value": "832-536-8802"
    },
    {
      "ID": "custom_knock_w_number",
      "type": "STRING",
      "value": "832-281-5617"
    },
    {
      "ID": "custom_knock_z_number",
      "type": "STRING",
      "value": "832-979-1424"
    },
    {
      "ID": "custom_knock_ads_title",
      "type": "STRING",
      "value": "META Social Ads"
    },
    {
      "ID": "custom_knock_al_number",
      "type": "STRING",
      "value": "832-210-1331"
    },
    {
      "ID": "custom_knock_amap_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=amap"
    },
    {
      "ID": "custom_knock_ar_number",
      "type": "STRING",
      "value": "832-479-4909"
    },
    {
      "ID": "custom_knock_bnr_title",
      "type": "STRING",
      "value": "Banners"
    },
    {
      "ID": "custom_knock_cl_number",
      "type": "STRING",
      "value": "832-323-6067"
    },
    {
      "ID": "custom_knock_fb_number",
      "type": "STRING",
      "value": "832-843-8637"
    },
    {
      "ID": "custom_knock_fl_number",
      "type": "STRING",
      "value": "832-669-5319"
    },
    {
      "ID": "custom_knock_gp_number",
      "type": "STRING",
      "value": "832-536-8101"
    },
    {
      "ID": "custom_knock_lcs_title",
      "type": "STRING",
      "value": "Local Search"
    },
    {
      "ID": "custom_knock_lgp_title",
      "type": "STRING",
      "value": "LE Google Performance Max"
    },
    {
      "ID": "custom_knock_osoc_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=osoc"
    },
    {
      "ID": "custom_knock_ppn_title",
      "type": "STRING",
      "value": "Property Phone Number"
    },
    {
      "ID": "custom_ads_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_ads_number",
      "type": "STRING",
      "value": "832-648-2372"
    },
    {
      "ID": "custom_knock_amap_title",
      "type": "STRING",
      "value": "Apartment Map"
    },
    {
      "ID": "custom_knock_bcard_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=bcard"
    },
    {
      "ID": "custom_knock_bnr_number",
      "type": "STRING",
      "value": "832-583-3508"
    },
    {
      "ID": "custom_knock_cfres_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=cfres"
    },
    {
      "ID": "custom_knock_company_id",
      "type": "STRING",
      "value": "2416"
    },
    {
      "ID": "custom_knock_lcs_number",
      "type": "STRING",
      "value": "832-966-3815"
    },
    {
      "ID": "custom_knock_lgp_number",
      "type": "STRING",
      "value": "832-669-5152"
    },
    {
      "ID": "custom_knock_osoc_title",
      "type": "STRING",
      "value": "Organic Social"
    },
    {
      "ID": "custom_knock_ppcnk_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=ppcnk"
    },
    {
      "ID": "custom_knock_ppn_number",
      "type": "STRING",
      "value": "832-957-2970"
    },
    {
      "ID": "custom_knock_psocl_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=psocl"
    },
    {
      "ID": "custom_seo_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_amap_number",
      "type": "STRING",
      "value": "832-479-2144"
    },
    {
      "ID": "custom_knock_bandit_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=bandit"
    },
    {
      "ID": "custom_knock_bcard_title",
      "type": "STRING",
      "value": "Business Card"
    },
    {
      "ID": "custom_knock_cfres_title",
      "type": "STRING",
      "value": "Corporate Website"
    },
    {
      "ID": "custom_knock_flyers_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=flyers"
    },
    {
      "ID": "custom_knock_osoc_number",
      "type": "STRING",
      "value": "832-583-2123"
    },
    {
      "ID": "custom_knock_ppcnk_title",
      "type": "STRING",
      "value": "PPC - Nonbrand Keywords"
    },
    {
      "ID": "custom_knock_psocl_title",
      "type": "STRING",
      "value": "Paid Social"
    },
    {
      "ID": "custom_pet_screening_url",
      "type": "STRING",
      "value": "https://app.petscreening.com/"
    },
    {
      "ID": "custom_hubspot_company_id",
      "type": "STRING",
      "value": "39659820981"
    },
    {
      "ID": "custom_knock_bandit_title",
      "type": "STRING",
      "value": "Bandit Signs"
    },
    {
      "ID": "custom_knock_bcard_number",
      "type": "STRING",
      "value": "832-662-7061"
    },
    {
      "ID": "custom_knock_cfres_number",
      "type": "STRING",
      "value": "832-906-4139"
    },
    {
      "ID": "custom_knock_chatgpt_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=CHATGPT"
    },
    {
      "ID": "custom_knock_community_id",
      "type": "STRING",
      "value": "f6e811f05e24b64a"
    },
    {
      "ID": "custom_knock_dirmail_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=dirmail"
    },
    {
      "ID": "custom_knock_flyers_title",
      "type": "STRING",
      "value": "Flyers"
    },
    {
      "ID": "custom_knock_ppcnk_number",
      "type": "STRING",
      "value": "832-843-2855"
    },
    {
      "ID": "custom_knock_propbro_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=propbro"
    },
    {
      "ID": "custom_knock_psocl_number",
      "type": "STRING",
      "value": "832-909-1229"
    },
    {
      "ID": "custom_knock_bandit_number",
      "type": "STRING",
      "value": "832-536-8178"
    },
    {
      "ID": "custom_knock_chatgpt_title",
      "type": "STRING",
      "value": "Chat GPT"
    },
    {
      "ID": "custom_knock_company_token",
      "type": "STRING",
      "value": "dbb65032104511ee8efd1217b1b18aa3"
    },
    {
      "ID": "custom_knock_dirmail_title",
      "type": "STRING",
      "value": "Direct Mailer"
    },
    {
      "ID": "custom_knock_flyers_number",
      "type": "STRING",
      "value": "832-761-4631"
    },
    {
      "ID": "custom_knock_propbro_title",
      "type": "STRING",
      "value": "Property Brochure"
    },
    {
      "ID": "custom_knock_revcards_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=revcards"
    },
    {
      "ID": "custom_social_subscription",
      "type": "STRING",
      "value": "essential"
    },
    {
      "ID": "custom_knock_chatgpt_number",
      "type": "STRING",
      "value": "832-662-1658"
    },
    {
      "ID": "custom_knock_dirmail_number",
      "type": "STRING",
      "value": "832-481-6019"
    },
    {
      "ID": "custom_knock_propbro_number",
      "type": "STRING",
      "value": "832-662-5880"
    },
    {
      "ID": "custom_knock_revcards_title",
      "type": "STRING",
      "value": "Review Cards"
    },
    {
      "ID": "custom_website_subscription",
      "type": "STRING",
      "value": "turnkey"
    },
    {
      "ID": "custom_knock_revcards_number",
      "type": "STRING",
      "value": "832-234-9327"
    },
    {
      "ID": "custom_knock_maintenance_link",
      "type": "STRING",
      "value": "https://www.auraatwestchase.com?utm_knock=maintenance"
    },
    {
      "ID": "custom_knock_maintenance_title",
      "type": "STRING",
      "value": "Maintenance"
    },
    {
      "ID": "custom_knock_tour_button_popup",
      "type": "STRING",
      "value": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>"
    },
    {
      "ID": "custom_property_featured_video",
      "type": "STRING",
      "value": "https://media.multihub.io/property/6767906449166922/019e60cf-ad4e-732e-9605-f109bfec5d27.mp4"
    },
    {
      "ID": "custom_knock_maintenance_number",
      "type": "STRING",
      "value": "832-376-6321"
    },
    {
      "ID": "custom_ppc_tracking_phone_number",
      "type": "STRING",
      "value": "832-536-8101"
    }
  ],
  "custom_csm": "cameron@repli360.com",
  "custom_qb_id": "5640",
  "custom_repli_id": "18004664758",
  "custom_realpage_id": "5587917",
  "custom_knock_a_link": "https://www.auraatwestchase.com?utm_knock=a",
  "custom_knock_g_link": "https://www.auraatwestchase.com?utm_knock=g",
  "custom_knock_r_link": "https://www.auraatwestchase.com?utm_knock=r",
  "custom_knock_w_link": "https://www.auraatwestchase.com?utm_knock=w",
  "custom_knock_z_link": "https://www.auraatwestchase.com?utm_knock=z",
  "custom_google_gtm_id": "GTM-NPRMPS3R",
  "custom_knock_a_title": "Apartments.com",
  "custom_knock_al_link": "https://www.auraatwestchase.com?utm_knock=al",
  "custom_knock_ar_link": "https://www.auraatwestchase.com?utm_knock=ar",
  "custom_knock_cl_link": "https://www.auraatwestchase.com?utm_knock=cl",
  "custom_knock_fb_link": "https://www.auraatwestchase.com?utm_knock=fb",
  "custom_knock_fl_link": "https://www.auraatwestchase.com?utm_knock=fl",
  "custom_knock_g_title": "Google",
  "custom_knock_gp_link": "https://www.auraatwestchase.com?utm_knock=gp",
  "custom_knock_r_title": "Rent.com",
  "custom_knock_w_title": "Property Website",
  "custom_knock_z_title": "Zillow",
  "custom_knock_a_number": "832-307-0771",
  "custom_knock_ads_link": "https://www.auraatwestchase.com?utm_knock=ads",
  "custom_knock_al_title": "Apartment List",
  "custom_knock_ar_title": "Apartment Ratings",
  "custom_knock_bnr_link": "https://www.auraatwestchase.com?utm_knock=bnr",
  "custom_knock_cl_title": "Craigslist",
  "custom_knock_fb_title": "Facebook",
  "custom_knock_fl_title": "Flag",
  "custom_knock_g_number": "832-263-7859",
  "custom_knock_gp_title": "Google (paid)",
  "custom_knock_lcs_link": "https://www.auraatwestchase.com?utm_knock=lcs",
  "custom_knock_lgp_link": "https://www.auraatwestchase.com?utm_knock=lgp",
  "custom_knock_ppn_link": "https://www.auraatwestchase.com?utm_knock=ppn",
  "custom_knock_r_number": "832-536-8802",
  "custom_knock_w_number": "832-281-5617",
  "custom_knock_z_number": "832-979-1424",
  "custom_knock_ads_title": "META Social Ads",
  "custom_knock_al_number": "832-210-1331",
  "custom_knock_amap_link": "https://www.auraatwestchase.com?utm_knock=amap",
  "custom_knock_ar_number": "832-479-4909",
  "custom_knock_bnr_title": "Banners",
  "custom_knock_cl_number": "832-323-6067",
  "custom_knock_fb_number": "832-843-8637",
  "custom_knock_fl_number": "832-669-5319",
  "custom_knock_gp_number": "832-536-8101",
  "custom_knock_lcs_title": "Local Search",
  "custom_knock_lgp_title": "LE Google Performance Max",
  "custom_knock_osoc_link": "https://www.auraatwestchase.com?utm_knock=osoc",
  "custom_knock_ppn_title": "Property Phone Number",
  "custom_ads_subscription": "essential",
  "custom_knock_ads_number": "832-648-2372",
  "custom_knock_amap_title": "Apartment Map",
  "custom_knock_bcard_link": "https://www.auraatwestchase.com?utm_knock=bcard",
  "custom_knock_bnr_number": "832-583-3508",
  "custom_knock_cfres_link": "https://www.auraatwestchase.com?utm_knock=cfres",
  "custom_knock_company_id": "2416",
  "custom_knock_lcs_number": "832-966-3815",
  "custom_knock_lgp_number": "832-669-5152",
  "custom_knock_osoc_title": "Organic Social",
  "custom_knock_ppcnk_link": "https://www.auraatwestchase.com?utm_knock=ppcnk",
  "custom_knock_ppn_number": "832-957-2970",
  "custom_knock_psocl_link": "https://www.auraatwestchase.com?utm_knock=psocl",
  "custom_seo_subscription": "essential",
  "custom_knock_amap_number": "832-479-2144",
  "custom_knock_bandit_link": "https://www.auraatwestchase.com?utm_knock=bandit",
  "custom_knock_bcard_title": "Business Card",
  "custom_knock_cfres_title": "Corporate Website",
  "custom_knock_flyers_link": "https://www.auraatwestchase.com?utm_knock=flyers",
  "custom_knock_osoc_number": "832-583-2123",
  "custom_knock_ppcnk_title": "PPC - Nonbrand Keywords",
  "custom_knock_psocl_title": "Paid Social",
  "custom_pet_screening_url": "https://app.petscreening.com/",
  "custom_hubspot_company_id": "39659820981",
  "custom_knock_bandit_title": "Bandit Signs",
  "custom_knock_bcard_number": "832-662-7061",
  "custom_knock_cfres_number": "832-906-4139",
  "custom_knock_chatgpt_link": "https://www.auraatwestchase.com?utm_knock=CHATGPT",
  "custom_knock_community_id": "f6e811f05e24b64a",
  "custom_knock_dirmail_link": "https://www.auraatwestchase.com?utm_knock=dirmail",
  "custom_knock_flyers_title": "Flyers",
  "custom_knock_ppcnk_number": "832-843-2855",
  "custom_knock_propbro_link": "https://www.auraatwestchase.com?utm_knock=propbro",
  "custom_knock_psocl_number": "832-909-1229",
  "custom_knock_bandit_number": "832-536-8178",
  "custom_knock_chatgpt_title": "Chat GPT",
  "custom_knock_company_token": "dbb65032104511ee8efd1217b1b18aa3",
  "custom_knock_dirmail_title": "Direct Mailer",
  "custom_knock_flyers_number": "832-761-4631",
  "custom_knock_propbro_title": "Property Brochure",
  "custom_knock_revcards_link": "https://www.auraatwestchase.com?utm_knock=revcards",
  "custom_social_subscription": "essential",
  "custom_knock_chatgpt_number": "832-662-1658",
  "custom_knock_dirmail_number": "832-481-6019",
  "custom_knock_propbro_number": "832-662-5880",
  "custom_knock_revcards_title": "Review Cards",
  "custom_website_subscription": "turnkey",
  "custom_knock_revcards_number": "832-234-9327",
  "custom_knock_maintenance_link": "https://www.auraatwestchase.com?utm_knock=maintenance",
  "custom_knock_maintenance_title": "Maintenance",
  "custom_knock_tour_button_popup": "<button onclick=\"event.preventDefault(); knockDoorway.openScheduling();\">Book tour</button>",
  "custom_property_featured_video": "https://media.multihub.io/property/6767906449166922/019e60cf-ad4e-732e-9605-f109bfec5d27.mp4",
  "custom_knock_maintenance_number": "832-376-6321",
  "custom_ppc_tracking_phone_number": "832-536-8101",
  "custom_audioeye_site_id": "ae7cb1f6-d326-4457-8b70-6e2839ac6621",
  "custom_audioeye_site_hash": "abe2f8f4525613feccbdb54cc0bf9396"
};

export const generatedAt = '2026-11-02T22:19:20.352Z';
